// src/utils/feedsConfig.js
export const feedsConfig = {
  recent: [
    {
      id: 'recent-0',
      type: 'normal',
      apiEndpoint: '&schema=united_states_of_america&table=all_recents&order_by=created_at&skip=0',
      title: 'Recents',
      feedName: 'Recent',
      branch: 'N/A',
      topic: 'N/A',
      buttonName: 'Document',
      viewAllLink: '/us/recents'
    },
    {
      id: 'recent-1',
      type: 'normal',
      apiEndpoint: '&schema=united_states_of_america&table=all_recents&order_by=created_at&skip=1',
      title: 'Recents',
      feedName: 'Recent',
      branch: 'N/A',
      topic: 'N/A',
      buttonName: 'Document',
      viewAllLink: '/us/recents'
    },
    {
      id: 'recent-2',
      type: 'normal',
      apiEndpoint: '&schema=united_states_of_america&table=all_recents&order_by=created_at&skip=2',
      title: 'Recents',
      feedName: 'Recent',
      branch: 'N/A',
      topic: 'N/A',
      buttonName: 'Document',
      viewAllLink: '/us/recents'
    },
    {
      id: 'recent-3',
      type: 'normal',
      apiEndpoint: '&schema=united_states_of_america&table=all_recents&order_by=created_at&skip=3',
      title: 'Recents',
      feedName: 'Recent',
      branch: 'N/A',
      topic: 'N/A',
      buttonName: 'Document',
      viewAllLink: '/us/recents'
    },
    {
      id: 'recent-4',
      type: 'normal',
      apiEndpoint: '&schema=united_states_of_america&table=all_recents&order_by=created_at&skip=4',
      title: 'Recents',
      feedName: 'Recent',
      branch: 'N/A',
      topic: 'N/A',
      buttonName: 'Document',
      viewAllLink: '/us/recents'
    },
    {
      id: 'recent-5',
      type: 'normal',
      apiEndpoint: '&schema=united_states_of_america&table=all_recents&order_by=created_at&skip=5',
      title: 'Recents',
      feedName: 'Recent',
      branch: 'N/A',
      topic: 'N/A',
      buttonName: 'Document',
      viewAllLink: '/us/recents'
    },
    {
      id: 'recent-6',
      type: 'normal',
      apiEndpoint: '&schema=united_states_of_america&table=all_recents&order_by=created_at&skip=6',
      title: 'Recents',
      feedName: 'Recent',
      branch: 'N/A',
      topic: 'N/A',
      buttonName: 'Document',
      viewAllLink: '/us/recents'
    },
    {
      id: 'recent-7',
      type: 'normal',
      apiEndpoint: '&schema=united_states_of_america&table=all_recents&order_by=created_at&skip=7',
      title: 'Recents',
      feedName: 'Recent',
      branch: 'N/A',
      topic: 'N/A',
      buttonName: 'Document',
      viewAllLink: '/us/recents'
    },
    {
      id: 'recent-8',
      type: 'normal',
      apiEndpoint: '&schema=united_states_of_america&table=all_recents&order_by=created_at&skip=8',
      title: 'Recents',
      feedName: 'Recent',
      branch: 'N/A',
      topic: 'N/A',
      buttonName: 'Document',
      viewAllLink: '/us/recents'
    },
    {
      id: 'recent-9',
      type: 'normal',
      apiEndpoint: '&schema=united_states_of_america&table=all_recents&order_by=created_at&skip=9',
      title: 'Recents',
      feedName: 'Recent',
      branch: 'N/A',
      topic: 'N/A',
      buttonName: 'Document',
      viewAllLink: '/us/recents'
    }
  ],

  legislative: [
    {
      id: 'bills',
      type: 'normal',
      apiEndpoint: '&schema=united_states_of_america&table=congressional_bills&order_by=action_date&skip=0',
      title: 'Bill Updates',
      feedName: 'Bills',
      branch: 'Legislative',
      topic: 'N/A',
      buttonName: 'Bill',
      viewAllLink: '/us/legislative',
      showOnHomePage: true
    },
      // Bills Enrolled Department (individual feed)
      {
        id: 'billsEnrolled',
        type: 'normal',
        apiEndpoint: '&schema=united_states_of_america&table=congressional_bills_enrolled&order_by=date_issued&skip=0',
        title: 'Bills Enrolled (Sent to President)',
        feedName: 'BillsEnrolled',
        branch: 'Legislative',
        topic: 'N/A',
        buttonName: 'Bill',
        viewAllLink: '/us/legislative',
        showOnHomePage: true
      },
  
      // Laws 
      {
        id: 'newLaws',
        type: 'normal',
        apiEndpoint: '&schema=united_states_of_america&table=public_and_private_laws&order_by=date_issued&skip=0',
        title: 'Laws',
        feedName: 'Laws',
        branch: 'Legislative',
        topic: 'N/A',
        buttonName: 'Law',
        viewAllLink: '/us/legislative',
        showOnHomePage: true
      },

      {
        id: 'congressionalReports',
        type: 'normal',
        apiEndpoint: '&skip=0&schema=united_states_of_america&table=congressional_reports&order_by=created_at',
        title: 'Congressional Reports',
        feedName: 'Congressional Reports',
        branch: 'Legislative',
        topic: 'N/A',
        buttonName: 'Report',
        viewAllLink: '/us/legislative',
        showOnHomePage: false
      },
  
      // Congressional Hearings Department (individual feed)
      {
        id: 'congressionalHearings',
        type: 'normal',
        apiEndpoint: '&schema=united_states_of_america&table=congressional_hearings&order_by=created_at&skip=0',
        title: 'Congressional Hearings',
        feedName: 'Hearings',
        branch: 'Legislative',
        topic: 'N/A',
        buttonName: 'Hearing',
        viewAllLink: '/us/legislative',
        showOnHomePage: true
      },
  
      // GAO Reports 
      {
        id: 'gaoReports',
        type: 'normal',
        apiEndpoint: '&schema=united_states_of_america&table=government_accountability_office_reports&order_by=created_at&skip=0',
        title: 'Government Accountability Office Reports',
        feedName: 'GAOReports',
        branch: 'Legislative',
        topic: 'N/A',
        buttonName: 'Document',
        viewAllLink: '/us/legislative',
        showOnHomePage: false

      },
 // House of Representatives (carousel-based)
 {
  id: 'house',
  type: 'carousel',
  departmentTitle: 'House of Representatives',
  departmentLink: '/us/house',
  showOnHomePage: false,
  carouselItems: [
    {
      id: 'house-member-featured',
      type: 'member',
      memberType: 'house',
      title: 'Featured Representative',
      
    },
    {
      id: 'houseFloor',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=house_floor_activity&order_by=created_at',
      title: 'Floor Activity',
      feedName: 'House Floor Activity',
      branch: 'Legislative',
      topic: 'N/A',
      buttonName: 'Document',
      showOnHomePage: false
    },
    {
      id: 'houseCommitteeAgri',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=committee_on_agriculture_meeting_feed&order_by=created_at',
      title: 'Agriculture Committee',
      feedName: 'House Agriculture Committee',
      branch: 'Legislative',
      topic: 'N/A',
      buttonName: 'Document',
      showOnHomePage: false
    },
    {
      id: 'houseCommitteeArmed',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=committee_on_armed_services_meeting_feed&order_by=created_at',
      title: 'Armed Services Committee',
      feedName: 'House Armed Services Committee',
      branch: 'Legislative',
      topic: 'N/A',
      buttonName: 'Document',
      showOnHomePage: false
    },
    {
      id: 'houseCommitteeFinancial',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=committee_on_financial_services_meeting_feed&order_by=created_at',
      title: 'Financial Services Committee',
      feedName: 'House Financial Services Committee',
      branch: 'Legislative',
      topic: 'N/A',
      buttonName: 'Document',
      showOnHomePage: false
    },
    {
      id: 'houseCommitteeJudiciary',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=committee_on_the_judiciary_meeting_feed&order_by=created_at',
      title: 'Judiciary Committee',
      feedName: 'House Judiciary Committee',
      branch: 'Legislative',
      topic: 'N/A',
      buttonName: 'Document',
      showOnHomePage: false
    },
    {
      id: 'houseCommitteeForeign',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=committee_on_foreign_affairs_meeting_feed&order_by=created_at',
      title: 'Foreign Affairs Committee',
      feedName: 'House Foreign Affairs Committee',
      branch: 'Legislative',
      topic: 'N/A',
      buttonName: 'Document',
      showOnHomePage: false
    },
    {
      id: 'house-viewall',
      type: 'viewall',
      buttonText: 'View all House of Representatives news',
      buttonLink: '/us/house'
    }
  ]
},
{
  id: 'senate',
  type: 'carousel',
  departmentTitle: 'United States Senate',
  departmentLink: '/us/senate',
  showOnHomePage: false,
  carouselItems: [

    {
      id: 'senate-member-featured',
      type: 'member',
      memberType: 'senate',
      title: 'Featured Senator',
    },
    {
      id: 'senateCommitteeArmed',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=senate_committee_news&order_by=created_at&filter_column=committee&filter_string=Committee%20on%20Armed%20Services',
      title: 'Armed Services Committee',
      feedName: 'Senate Armed Services Committee',
      branch: 'Legislative',
      topic: 'N/A',
      buttonName: 'News',
      showOnHomePage: false
    },
    {
      id: 'senateCommitteeFinance',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=senate_committee_news&order_by=created_at&filter_column=committee&filter_string=Committee%20on%20Finance',
      title: 'Finance Committee',
      feedName: 'Senate Finance Committee',
      branch: 'Legislative',
      topic: 'N/A',
      buttonName: 'News',
      showOnHomePage: false
    },
    {
      id: 'senateCommitteeJudiciary',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=senate_committee_news&order_by=created_at&filter_column=committee&filter_string=Committee%20on%20the%20Judiciary',
      title: 'Judiciary Committee',
      feedName: 'Senate Judiciary Committee',
      branch: 'Legislative',
      topic: 'N/A',
      buttonName: 'News',
      showOnHomePage: false
    },
    {
      id: 'senateCommitteeForeign',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=senate_committee_news&order_by=created_at&filter_column=committee&filter_string=Committee%20on%20Foreign%20Relations',
      title: 'Foreign Relations Committee',
      feedName: 'Senate Foreign Relations Committee',
      branch: 'Legislative',
      topic: 'N/A',
      buttonName: 'News',
      showOnHomePage: false
    },
    {
      id: 'senate-viewall',
      type: 'viewall',
      buttonText: 'View all Senate news',
      buttonLink: '/us/senate'
    }
  ]
},
  ],
  



  executive: [
    // White House 
    {
      id: 'whitehouse',
      type: 'carousel',
      departmentTitle: 'White House',
      departmentLink: '/us/whitehouse',
      
      carouselItems: [
        {
          id: 'wh',
          apiEndpoint: '&skip=0&schema=united_states_of_america&table=the_white_house&order_by=created_at',
          title: 'Briefing Room',
          feedName: 'White House Briefing Room',
          branch: 'Executive',
          topic: 'N/A',
          buttonName: '',
          showOnHomePage: true
        },
        {
          id: 'pa',
          apiEndpoint: '&skip=0&schema=united_states_of_america&table=the_white_house&order_by=created_at&filter_column=category&filter_string=Presidential%20Actions',
          title: 'Presidential Actions',
          feedName: 'Presidential Actions',
          branch: 'Executive',
          topic: 'N/A',
          buttonName: '',
          showOnHomePage: true
        },
        {
          id: 'whdocs',
          apiEndpoint: '&skip=0&schema=united_states_of_america&table=compilation_of_presidential_documents&order_by=created_at',
          title: 'Presidential Documents',
          feedName: 'Presidential Documents',
          branch: 'Executive',
          topic: 'N/A',
          buttonName: 'Doc',
          showOnHomePage: true
        },
        {
          id: 'wh-viewall',
          type: 'viewall',
          buttonText: 'View all White House news',
          buttonLink: '/us/whitehouse'
        }
      ]
    },

    // Department of State (carousel-based)
    {
      id: 'state',
      type: 'carousel',
      departmentTitle: 'Department of State',
      departmentLink: '/us/departmentofstate',
      showOnHomePage: false,
      carouselItems: [
        {
          id: 'stateDepartment2',
          apiEndpoint: '&skip=0&schema=united_states_of_america&table=state&order_by=created_at',
          title: 'News',
          feedName: 'Department of State News',
          branch: 'Executive',
          topic: 'N/A',
          buttonName: '',
          showOnHomePage: false
        },
        {
          id: 'frState',
          apiEndpoint: '&skip=0&schema=united_states_of_america&table=state&order_by=created_at&filter_column=collection_name&filter_string=Department%20of%20State%20Documents',
          title: 'Documents',
          feedName: 'Department of State Documents',
          branch: 'Executive',
          topic: 'N/A',
          buttonName: '',
          showOnHomePage: false
        },
        {
          id: 'state-viewall',
          type: 'viewall',
          buttonText: 'View all Department of State news',
          buttonLink: '/us/departmentofstate'
        }
      ]
    },

    // Department of Treasury (carousel-based)
    {
      id: 'treasury',
      type: 'carousel',
      departmentTitle: 'Department of Treasury',
      departmentLink: '/us/departmentoftreasury',
      showOnHomePage: false,
      carouselItems: [
        {
          id: 'treasuryDepartment',
          apiEndpoint: '&skip=0&schema=united_states_of_america&table=treasury&order_by=created_at',
          title: 'News',
          feedName: 'Department of Treasury News',
          branch: 'Executive',
          topic: 'Economy',
          buttonName: '',
          showOnHomePage: false
        },
        {
          id: 'treasuryDocs',
          apiEndpoint: '&skip=0&schema=united_states_of_america&table=treasury&order_by=created_at&filter_column=agency&filter_string=Treasury%20Department',
          title: 'Documents',
          feedName: 'Department of Treasury Documents',
          branch: 'Executive',
          topic: 'Economy',
          buttonName: '',
          showOnHomePage: false
        },
        {
          id: 'treasury-viewall',
          type: 'viewall',
          buttonText: 'View all Department of Treasury news',
          buttonLink: '/us/departmentoftreasury'
        }
      ]
    },

    // Department of Defense (carousel-based)
    {
      id: 'defense',
      type: 'carousel',
      departmentTitle: 'Department of Defense',
      departmentLink: '/us/departmentofdefense',
      showOnHomePage: false,
      carouselItems: [
        {
          id: 'defenseDepartment',
          apiEndpoint: '&skip=0&schema=united_states_of_america&table=defense&order_by=created_at',
          title: 'News',
          feedName: 'Department of Defense News',
          branch: 'Executive',
          topic: 'Foreign Affairs',
          buttonName: '',
          showOnHomePage: false
        },
        {
          id: 'frDefense',
          apiEndpoint: '&skip=0&schema=united_states_of_america&table=defense&order_by=created_at&filter_column=agency&filter_string=Defense%20Department',
          title: 'Documents',
          feedName: 'Department of Defense Documents',
          branch: 'Executive',
          topic: 'Foreign Affairs',
          buttonName: '',
          showOnHomePage: false
        },
        {
          id: 'armyDocs',
          apiEndpoint: '&skip=0&schema=united_states_of_america&table=defense&order_by=created_at&filter_column=agency&filter_string=Army%20Department',
          title: 'Army Documents',
          feedName: 'Army Documents',
          branch: 'Executive',
          topic: 'N/A',
          buttonName: '',
          feedType: 'department',
          showOnHomePage: false
        },
        {
          id: 'navyDocs',
          apiEndpoint: '&table_name=defense&agency=Navy%20Department',
          title: 'Navy Documents',
          feedName: 'Navy Documents',
          branch: 'Executive',
          topic: 'N/A',
          buttonName: '',
          feedType: 'department',
          showOnHomePage: false
        },
        {
          id: 'defense-viewall',
          type: 'viewall',
          buttonText: 'View all Department of Defense news',
          buttonLink: '/us/departmentofdefense'
        }
      ]
    },

    // Department of Justice (carousel-based)
    {
      id: 'justice',
      type: 'carousel',
      departmentTitle: 'Department of Justice',
      departmentLink: '/us/departmentofjustice',
      showOnHomePage: false,
      carouselItems: [
        {
          id: 'justiceNews',
          apiEndpoint: '&skip=0&schema=united_states_of_america&table=justice&order_by=created_at',
          title: 'News',
          feedName: 'Department of Justice News',
          branch: 'Executive',
          topic: 'N/A',
          buttonName: 'Document',
          showOnHomePage: false
        },
        {
          id: 'justiceDocs',
          apiEndpoint: '&skip=0&schema=united_states_of_america&table=justice&order_by=created_at&filter_column=agency&filter_string=Justice%20Department',
          title: 'Documents',
          feedName: 'Department of Justice Documents',
          branch: 'Executive',
          topic: 'N/A',
          buttonName: '',
          showOnHomePage: false
        },
        {
          id: 'justice-viewall',
          type: 'viewall',
          buttonText: 'View all Department of Justice news',
          buttonLink: '/us/departmentofjustice'
        }
      ]
    },

    // Department of Transportation (carousel-based)
    {
      id: 'transportation',
      type: 'carousel',
      departmentTitle: 'Department of Transportation',
      departmentLink: '/us/departmentoftransportation',
      showOnHomePage: false,
      carouselItems: [
        {
          id: 'transDepartment',
          apiEndpoint: '&skip=0&schema=united_states_of_america&table=transportation&order_by=created_at&filter_column=agency&filter_string=Transportation%20Department',
          title: 'Documents',
          feedName: 'Department of Transportation Documents',
          branch: 'Executive',
          topic: 'N/A',
          buttonName: '',
          showOnHomePage: false
        },
        {
          id: 'spaceDocs',
          apiEndpoint: '&table_name=transportation&agency=Commercial%20Space%20Transportation%20Office',
          title: 'Commercial Space Transportation Office',
          feedName: 'Commercial Space Transportation Office',
          branch: 'Executive',
          topic: 'N/A',
          buttonName: '',
          feedType: 'department',
          showOnHomePage: false
        },
        {
          id: 'trans-viewall',
          type: 'viewall',
          buttonText: 'View all Department of Transportation news',
          buttonLink: '/us/departmentoftransportation'
        }
      ]
    },

    // Department of the Interior (carousel-based)
    {
      id: 'interior',
      type: 'carousel',
      departmentTitle: 'Department of the Interior',
      departmentLink: '/us/departmentoftheinterior',
      showOnHomePage: false,
      carouselItems: [
        {
          id: 'theInteriorDepartment',
          apiEndpoint: '&skip=0&schema=united_states_of_america&table=department_of_interior_news&order_by=created_at',
          title: 'News',
          feedName: 'Department of the Interior News',
          branch: 'Executive',
          topic: 'N/A',
          buttonName: 'Document',
          showOnHomePage: false
        },
        {
          id: 'interiorDocs',
          apiEndpoint: '&skip=0&schema=united_states_of_america&table=interior&order_by=created_at&filter_column=agency&filter_string=Interior%20Department',
          title: 'Documents',
          feedName: 'Department of the Interior Documents',
          branch: 'Executive',
          topic: 'N/A',
          buttonName: '',
          showOnHomePage: false
        },
        {
          id: 'interior-viewall',
          type: 'viewall',
          buttonText: 'View all Department of the Interior news',
          buttonLink: '/us/departmentoftheinterior'
        }
      ]
    },

    // Department of Agriculture (carousel-based)
    {
      id: 'agriculture',
      type: 'carousel',
      departmentTitle: 'Department of Agriculture',
      departmentLink: '/us/departmentofagriculture',
      showOnHomePage: false,
      carouselItems: [
        {
          id: 'agricultureDepartment5',
          apiEndpoint: '&skip=0&schema=united_states_of_america&table=environment&order_by=created_at',
          title: 'News',
          feedName: 'Department of Agriculture News',
          branch: 'Executive',
          topic: 'Environment',
          buttonName: '',
          showOnHomePage: false
        },
        {
          id: 'agDocs',
          apiEndpoint: '&skip=0&schema=united_states_of_america&table=environment&order_by=created_at&filter_column=agency&filter_string=Department%20of%20Agriculture',
          title: 'Documents',
          feedName: 'Department of Agriculture Documents',
          branch: 'Executive',
          topic: 'N/A',
          buttonName: '',
          showOnHomePage: false
        },
        {
          id: 'agriculture-viewall',
          type: 'viewall',
          buttonText: 'View all Department of Agriculture news',
          buttonLink: '/us/departmentofagriculture',
          showOnHomePage: false
        }
      ]
    },

    // Department of Commerce (carousel-based)
    {
      id: 'commerce',
      type: 'carousel',
      departmentTitle: 'Department of Commerce',
      departmentLink: '/us/departmentofcommerce',
      showOnHomePage: false,
      carouselItems: [
        {
          id: 'commerceDepartment',
          apiEndpoint: '&skip=0&schema=united_states_of_america&table=commerce&order_by=created_at',
          title: 'News',
          feedName: 'Department of Commerce News',
          branch: 'Executive',
          topic: 'Economy',
          buttonName: '',
          showOnHomePage: false
        },
        {
          id: 'commerceDocs',
          apiEndpoint: '&skip=0&schema=united_states_of_america&table=commerce&order_by=created_at&filter_column=agency&filter_string=Commerce%20Department',
          title: 'Documents',
          feedName: 'Department of Commerce Documents',
          branch: 'Executive',
          topic: 'N/A',
          buttonName: '',
          showOnHomePage: false
        },
        {
          id: 'censusBureau',
          apiEndpoint: '&table_name=commerce&agency=Census%20Bureau',
          title: 'Census Bureau Documents',
          feedName: 'Census Bureau Documents',
          branch: 'Executive',
          topic: 'N/A',
          buttonName: '',
          feedType: 'department',
          showOnHomePage: false
        },
        {
          id: 'economicAnalysis',
          apiEndpoint: '&table_name=commerce&agency=Economic%20Analysis%20Bureau',
          title: 'Economic Analysis Bureau Documents',
          feedName: 'Economic Analysis Bureau Documents',
          branch: 'Executive',
          topic: 'N/A',
          buttonName: '',
          feedType: 'department'
        },
        {
          id: 'commerce-viewall',
          type: 'viewall',
          buttonText: 'View all Department of Commerce news',
          buttonLink: '/us/departmentofcommerce'
        }
      ]
    },

    // Department of Labor (carousel-based)
    {
      id: 'labor',
      type: 'carousel',
      departmentTitle: 'Department of Labor',
      departmentLink: '/us/departmentoflabor',
      showOnHomePage: false,
      carouselItems: [
        {
          id: 'laborDepartment',
          apiEndpoint: '&skip=0&schema=united_states_of_america&table=labor&order_by=created_at',
          title: 'News',
          feedName: 'Department of Labor News',
          branch: 'Executive',
          topic: 'Economy',
          buttonName: '',
          showOnHomePage: false
        },
        {
          id: 'laborDocs',
          apiEndpoint: '&skip=0&schema=united_states_of_america&table=labor&order_by=created_at&filter_column=agency&filter_string=Labor%20Department',
          title: 'Documents',
          feedName: 'Department of Labor Documents',
          branch: 'Executive',
          topic: 'N/A',
          buttonName: '',
          showOnHomePage: false
        },
        {
          id: 'labor-viewall',
          type: 'viewall',
          buttonText: 'View all Department of Labor news',
          buttonLink: '/us/departmentoflabor'
        }
      ]
    },

    // Department of Health and Human Services (carousel-based)
    {
      id: 'health_and_human_services',
      type: 'carousel',
      departmentTitle: 'Department of Health and Human Services',
      departmentLink: '/us/departmentofhealth',
      showOnHomePage: false,
      carouselItems: [
        {
          id: 'healthAndHumanServicesDepartment',
          apiEndpoint: '&skip=0&schema=united_states_of_america&table=health_and_human_services&order_by=created_at',
          title: 'News',
          feedName: 'Department of Health and Human Services News',
          branch: 'Executive',
          topic: 'Health',
          buttonName: 'Document',
          showOnHomePage: false
        },
        {
          id: 'healthDocs',
          apiEndpoint: '&skip=0&schema=united_states_of_america&table=health_and_human_services&order_by=created_at&filter_column=agency&filter_string=Health%20and%20Human%20Services%20Department',
          title: 'Documents',
          feedName: 'Department of Health and Human Services Documents',
          branch: 'Executive',
          topic: 'N/A',
          buttonName: '',
          showOnHomePage: false
        },
        {
          id: 'health-viewall',
          type: 'viewall',
          buttonText: 'View all Health and Human Services news',
          buttonLink: '/us/departmentofhealth'
        }
      ]
    },

    // Department of Housing and Urban Development (carousel-based)
    {
      id: 'housing_and_urban_development',
      type: 'carousel',
      departmentTitle: 'Department of Housing and Urban Development',
      departmentLink: '/us/departmentofhousing',
      showOnHomePage: false,
      carouselItems: [
        {
          id: 'housingAndUrbanDevelopmentDepartment',
          apiEndpoint: '&skip=0&schema=united_states_of_america&table=housing_and_urban_development&order_by=created_at',
          title: 'News',
          feedName: 'Department of Housing and Urban Development News',
          branch: 'Executive',
          topic: 'Environment',
          buttonName: '',
          showOnHomePage: false
        },
        {
          id: 'housingDocs',
          apiEndpoint: '&skip=0&schema=united_states_of_america&table=housing_and_urban_development&order_by=created_at&filter_column=collection_name&filter_string=Department%20of%20Housing%20And%20Urban%20Development%20Documents',
          title: 'Documents',
          feedName: 'Department of Housing and Urban Development Documents',
          branch: 'Executive',
          topic: 'N/A',
          buttonName: '',
          showOnHomePage: false
        },
        {
          id: 'housing-viewall',
          type: 'viewall',
          buttonText: 'View all Housing and Urban Development news',
          buttonLink: '/us/departmentofhousing'
        }
      ]
    },

    // Department of Education (carousel-based)
    {
      id: 'education',
      type: 'carousel',
      departmentTitle: 'Department of Education',
      departmentLink: '/us/departmentofeducation',
      showOnHomePage: false,
      carouselItems: [
        {
          id: 'eduNews',
          apiEndpoint: '&skip=0&schema=united_states_of_america&table=education&order_by=created_at&filter_column=collection_name&filter_string=Department%20of%20Education%20Press%20Release',
          title: 'News',
          feedName: 'Department of Education News',
          branch: 'Executive',
          topic: 'N/A',
          buttonName: '',
          showOnHomePage: false
        },
        {
          id: 'eduDocs',
          apiEndpoint: '&skip=0&schema=united_states_of_america&table=education&order_by=created_at&filter_column=agency&filter_string=Education%20Department',
          title: 'Documents',
          feedName: 'Department of Education Documents',
          branch: 'Executive',
          topic: 'N/A',
          buttonName: '',
          showOnHomePage: false
        },
        {
          id: 'education-viewall',
          type: 'viewall',
          buttonText: 'View all Department of Education news',
          buttonLink: '/us/departmentofeducation'
        }
      ]
    },

    // Department of Energy (carousel-based)
{
  id: 'energy',
  type: 'carousel',
  departmentTitle: 'Department of Energy',
  departmentLink: '/us/departmentofenergy',
  showOnHomePage: false,
  carouselItems: [
    
    {
      id: 'energyNews',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=energy&order_by=created_at',
      title: 'News',
      feedName: 'Department of Energy News',
      branch: 'Executive',
      topic: 'Environment',
      buttonName: '',
      showOnHomePage: false
    },
    {
      id: 'energyDepartment',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=energy&order_by=created_at&filter_column=agency&filter_string=Energy%20Department',
      title: 'Documents',
      feedName: 'Department of Energy Documents',
      branch: 'Executive',
      topic: 'N/A',
      buttonName: '',
      showOnHomePage: false
    },
    {
      id: 'energyInfo',
      apiEndpoint: '&table_name=energy&agency=Energy%20Information%20Administration',
      title: 'Energy Information Administration',
      feedName: 'Energy Information Administration',
      branch: 'Executive',
      topic: 'N/A',
      buttonName: '',
      feedType: 'department',
      showOnHomePage: false
    },
    {
      id: 'energyReg',
      apiEndpoint: '&table_name=energy&agency=Federal%20Energy%20Regulatory%20Commission',
      title: 'Federal Energy Regulatory Commission',
      feedName: 'Federal Energy Regulatory Commission',
      branch: 'Executive',
      topic: 'N/A',
      buttonName: '',
      feedType: 'department',
      showOnHomePage: false
    },
    {
      id: 'energy-viewall',
      type: 'viewall',
      buttonText: 'View all Department of Energy news',
      buttonLink: '/us/departmentofenergy'
    }
  ]
},

// Department of Veterans Affairs (carousel-based)
{
  id: 'veterans_affairs',
  type: 'carousel',
  departmentTitle: "Department of Veterans' Affairs",
  departmentLink: '/us/departmentofveteransaffairs',
  showOnHomePage: false,
  carouselItems: [
    {
      id: 'veteransAffairsDepartment',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=veterans_affairs_news&order_by=created_at',
      title: 'News',
      feedName: "Department of Veterans' Affairs News",
      branch: 'Executive',
      topic: 'N/A',
      buttonName: '',
      showOnHomePage: false
    },
    {
      id: 'veterans-viewall',
      type: 'viewall',
      buttonText: "View all Veterans' Affairs news",
      buttonLink: '/us/departmentofveteransaffairs'
    }
  ]
},

// Department of Homeland Security (carousel-based)
{
  id: 'homeland_security',
  type: 'carousel',
  departmentTitle: 'Department of Homeland Security',
  departmentLink: '/us/departmentofhomeland',
  showOnHomePage: false,
  carouselItems: [
    {
      id: 'homelandDocs',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=homeland_security&order_by=created_at&filter_column=agency&filter_string=Homeland%20Security%20Department',
      title: 'Documents',
      feedName: 'Department of Homeland Security Documents',
      branch: 'Executive',
      topic: 'N/A',
      buttonName: '',
      showOnHomePage: false
    },
    {
      id: 'homeland-viewall',
      type: 'viewall',
      buttonText: 'View all Homeland Security news',
      buttonLink: '/us/departmentofhomeland'
    }
  ]
}
  ],

  // Add this new section to your feedsConfig:

whitehouse: [
  {
    id: 'whitehouseBriefing',
    type: 'normal',
    apiEndpoint: '&skip=0&schema=united_states_of_america&table=the_white_house&order_by=created_at',
    title: 'Briefing Room',
    feedName: 'White House Briefing Room',
    branch: 'Executive',
    topic: 'N/A',
    buttonName: '',
    viewAllLink: '/us/whitehouse',
    showOnHomePage: false,
  },
  {
    id: 'presidentialActions',
    type: 'normal',
    apiEndpoint: '&skip=0&schema=united_states_of_america&table=the_white_house&order_by=created_at&filter_column=category&filter_string=Presidential%20Actions',
    title: 'Presidential Actions',
    feedName: 'Presidential Actions',
    branch: 'Executive',
    topic: 'N/A',
    buttonName: 'Document',
    viewAllLink: '/us/whitehouse',
    showOnHomePage: true
  },
  {
    id: 'presidentialDocuments',
    type: 'normal',
    apiEndpoint: '&skip=0&schema=united_states_of_america&table=compilation_of_presidential_documents&order_by=created_at',
    title: 'Presidential Documents',
    feedName: 'Presidential Documents',
    branch: 'Executive',
    topic: 'N/A',
    buttonName: 'Doc',
    viewAllLink: '/us/whitehouse',
    showOnHomePage: true
  },
  {
    id: 'presidentialProclamations',
    type: 'normal',
    apiEndpoint: '&skip=0&schema=united_states_of_america&table=presidential_proclamation&order_by=created_at',
    title: 'Presidential Proclamations',
    feedName: 'Presidential Proclamations',
    branch: 'Executive',
    topic: 'N/A',
    buttonName: 'Document',
    viewAllLink: '/us/whitehouse',
    showOnHomePage: true
  }
],

  judicial: [
    {
      id: 'courtNews',
      type: 'normal',
      apiEndpoint: '&schema=united_states_of_america&table=uscourts&order_by=created_at&skip=0',
      title: 'U.S. Court News',
      feedName: 'CourtNews',
      branch: 'Judicial',
      topic: 'N/A',
      buttonName: 'Document',
      viewAllLink: '/us/judicial',
      showOnHomePage: true
    },
    {
      id: 'supremeCourtOpinions',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=supreme_court_opinions&order_by=created_at',
      title: 'Supreme Court Opinions',
      feedName: 'Supreme Court Opinions',
      branch: 'Judicial',
      topic: 'N/A',
      buttonName: 'Document',
      viewAllLink: '/us/judicial',
      showOnHomePage: false
    },
    {
      id: 'supremeCourtArguments',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=supreme_court_arguments&order_by=created_at',
      title: 'Supreme Court Arguments',
      feedName: 'Supreme Court Arguments',
      branch: 'Judicial',
      topic: 'N/A',
      buttonName: 'Document',
      viewAllLink: '/us/judicial',
      showOnHomePage: false
    },
    
    // Court of Appeals feeds
    {
      id: 'internationalTradeCourt',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=court_of_appeals&order_by=created_at&filter_column=collection_name&filter_string=US%20Court%20of%20International%20Trade',
      title: 'U.S. Court of International Trade',
      feedName: 'U.S. Court of International Trade',
      branch: 'Judicial',
      topic: 'N/A',
      buttonName: 'Document',
      viewAllLink: '/us/judicial',
      showOnHomePage: false
    },
    {
      id: 'federalCircuit',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=court_of_appeals&order_by=created_at&filter_column=collection_name&filter_string=Court%20of%20Appeals%20for%20the%20Thirteenth%20Circuit',
      title: 'Court of Appeals for the Federal Circuit',
      feedName: 'Court of Appeals for the Federal Circuit',
      branch: 'Judicial',
      topic: 'N/A',
      buttonName: 'Document',
      viewAllLink: '/us/judicial',
      showOnHomePage: false
    },
    {
      id: 'firstCircuit',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=court_of_appeals&order_by=created_at&filter_column=collection_name&filter_string=Court%20of%20Appeals%20for%20the%20First%20Circuit',
      title: 'Court of Appeals for the First Circuit',
      feedName: 'Court of Appeals for the First Circuit',
      branch: 'Judicial',
      topic: 'N/A',
      buttonName: 'Document',
      viewAllLink: '/us/judicial',
      showOnHomePage: false
    },
    {
      id: 'secondCircuit',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=court_of_appeals&order_by=created_at&filter_column=collection_name&filter_string=Court%20of%20Appeals%20for%20the%20Second%20Circuit',
      title: 'Court of Appeals for the Second Circuit',
      feedName: 'Court of Appeals for the Second Circuit',
      branch: 'Judicial',
      topic: 'N/A',
      buttonName: 'Document',
      viewAllLink: '/us/judicial',
      showOnHomePage: false
    },
    {
      id: 'thirdCircuit',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=court_of_appeals&order_by=created_at&filter_column=collection_name&filter_string=Court%20of%20Appeals%20for%20the%20Third%20Circuit',
      title: 'Court of Appeals for the Third Circuit',
      feedName: 'Court of Appeals for the Third Circuit',
      branch: 'Judicial',
      topic: 'N/A',
      buttonName: 'Document',
      viewAllLink: '/us/judicial',
      showOnHomePage: false
    },
    {
      id: 'fourthCircuit',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=court_of_appeals&order_by=created_at&filter_column=collection_name&filter_string=Court%20of%20Appeals%20for%20the%20Fourth%20Circuit',
      title: 'Court of Appeals for the Fourth Circuit',
      feedName: 'Court of Appeals for the Fourth Circuit',
      branch: 'Judicial',
      topic: 'N/A',
      buttonName: 'Document',
      viewAllLink: '/us/judicial',
      showOnHomePage: false
    },
    {
      id: 'fifthCircuit',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=court_of_appeals&order_by=created_at&filter_column=collection_name&filter_string=Court%20of%20Appeals%20for%20the%20Fifth%20Circuit',
      title: 'Court of Appeals for the Fifth Circuit',
      feedName: 'Court of Appeals for the Fifth Circuit',
      branch: 'Judicial',
      topic: 'N/A',
      buttonName: 'Document',
      viewAllLink: '/us/judicial',
      showOnHomePage: false
    },
    {
      id: 'sixthCircuit',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=court_of_appeals&order_by=created_at&filter_column=collection_name&filter_string=Court%20of%20Appeals%20for%20the%20Sixth%20Circuit',
      title: 'Court of Appeals for the Sixth Circuit',
      feedName: 'Court of Appeals for the Sixth Circuit',
      branch: 'Judicial',
      topic: 'N/A',
      buttonName: 'Document',
      viewAllLink: '/us/judicial',
      showOnHomePage: false
    },
    {
      id: 'seventhCircuit',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=court_of_appeals&order_by=created_at&filter_column=collection_name&filter_string=Court%20of%20Appeals%20for%20the%20Seventh%20Circuit',
      title: 'Court of Appeals for the Seventh Circuit',
      feedName: 'Court of Appeals for the Seventh Circuit',
      branch: 'Judicial',
      topic: 'N/A',
      buttonName: 'Document',
      viewAllLink: '/us/judicial',
      showOnHomePage: false
    },
    {
      id: 'eighthCircuit',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=court_of_appeals&order_by=created_at&filter_column=collection_name&filter_string=Court%20of%20Appeals%20for%20the%20Eighth%20Circuit',
      title: 'Court of Appeals for the Eighth Circuit',
      feedName: 'Court of Appeals for the Eighth Circuit',
      branch: 'Judicial',
      topic: 'N/A',
      buttonName: 'Document',
      viewAllLink: '/us/judicial',
      showOnHomePage: false
    },
    {
      id: 'ninthCircuit',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=court_of_appeals&order_by=created_at&filter_column=collection_name&filter_string=Court%20of%20Appeals%20for%20the%20Ninth%20Circuit',
      title: 'Court of Appeals for the Ninth Circuit',
      feedName: 'Court of Appeals for the Ninth Circuit',
      branch: 'Judicial',
      topic: 'N/A',
      buttonName: 'Document',
      viewAllLink: '/us/judicial',
      showOnHomePage: false
    },
    {
      id: 'tenthCircuit',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=court_of_appeals&order_by=created_at&filter_column=collection_name&filter_string=Court%20of%20Appeals%20for%20the%20Tenth%20Circuit',
      title: 'Court of Appeals for the Tenth Circuit',
      feedName: 'Court of Appeals for the Tenth Circuit',
      branch: 'Judicial',
      topic: 'N/A',
      buttonName: 'Document',
      viewAllLink: '/us/judicial',
      showOnHomePage: false
    },
    {
      id: 'eleventhCircuit',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=court_of_appeals&order_by=created_at&filter_column=collection_name&filter_string=Court%20of%20Appeals%20for%20the%20Eleventh%20Circuit',
      title: 'Court of Appeals for the Eleventh Circuit',
      feedName: 'Court of Appeals for the Eleventh Circuit',
      branch: 'Judicial',
      topic: 'N/A',
      buttonName: 'Document',
      viewAllLink: '/us/judicial',
      showOnHomePage: false
    },
    {
      id: 'dcCircuit',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=court_of_appeals&order_by=created_at&filter_column=collection_name&filter_string=Court%20of%20Appeals%20for%20the%20District%20of%20Columbia%20Circuit',
      title: 'Court of Appeals for the District of Columbia Circuit',
      feedName: 'Court of Appeals for the District of Columbia Circuit',
      branch: 'Judicial',
      topic: 'N/A',
      buttonName: 'Document',
      viewAllLink: '/us/judicial',
      showOnHomePage: false
    },
    // District Court feeds (continuing from previous)
{
  id: 'alndDistrictCourt',
  type: 'normal',
  apiEndpoint: '&skip=0&schema=united_states_of_america&table=state_judicial_publications&order_by=created_at&filter_column=feed_title&filter_string=District%20Court%20Northern%20District%20of%20Alabama',
  title: 'District Court Northern District of Alabama',
  feedName: 'District Court Northern District of Alabama',
  branch: 'Judicial',
  topic: 'N/A',
  buttonName: 'Document',
  viewAllLink: '/us/judicial',
  showOnHomePage: false
},
{
  id: 'alsdDistrictCourt',
  type: 'normal',
  apiEndpoint: '&skip=0&schema=united_states_of_america&table=state_judicial_publications&order_by=created_at&filter_column=feed_title&filter_string=District%20Court%20Southern%20District%20of%20Alabama',
  title: 'District Court Southern District of Alabama',
  feedName: 'District Court Southern District of Alabama',
  branch: 'Judicial',
  topic: 'N/A',
  buttonName: 'Document',
  viewAllLink: '/us/judicial',
  showOnHomePage: false
},
{
  id: 'almdDistrictCourt',
  type: 'normal',
  apiEndpoint: '&skip=0&schema=united_states_of_america&table=state_judicial_publications&order_by=created_at&filter_column=feed_title&filter_string=District%20Court%20Middle%20District%20of%20Alabama',
  title: 'District Court Middle District of Alabama',
  feedName: 'District Court Middle District of Alabama',
  branch: 'Judicial',
  topic: 'N/A',
  buttonName: 'Document',
  viewAllLink: '/us/judicial',
  showOnHomePage: false
},
{
  id: 'akdDistrictCourt',
  type: 'normal',
  apiEndpoint: '&skip=0&schema=united_states_of_america&table=state_judicial_publications&order_by=created_at&filter_column=feed_title&filter_string=District%20Court%20District%20of%20Alaska',
  title: 'District Court District of Alaska',
  feedName: 'District Court District of Alaska',
  branch: 'Judicial',
  topic: 'N/A',
  buttonName: 'Document',
  viewAllLink: '/us/judicial',
  showOnHomePage: false
},
{
  id: 'azdDistrictCourt',
  type: 'normal',
  apiEndpoint: '&skip=0&schema=united_states_of_america&table=state_judicial_publications&order_by=created_at&filter_column=feed_title&filter_string=District%20Court%20District%20of%20Arizona',
  title: 'District Court District of Arizona',
  feedName: 'District Court District of Arizona',
  branch: 'Judicial',
  topic: 'N/A',
  buttonName: 'Document',
  viewAllLink: '/us/judicial',
  showOnHomePage: false
},
{
  id: 'aredDistrictCourt',
  type: 'normal',
  apiEndpoint: '&skip=0&schema=united_states_of_america&table=state_judicial_publications&order_by=created_at&filter_column=feed_title&filter_string=District%20Court%20Eastern%20District%20of%20Arkansas',
  title: 'District Court Eastern District of Arkansas',
  feedName: 'District Court Eastern District of Arkansas',
  branch: 'Judicial',
  topic: 'N/A',
  buttonName: 'Document',
  viewAllLink: '/us/judicial',
  showOnHomePage: false
},
{
  id: 'caedDistrictCourt',
  type: 'normal',
  apiEndpoint: '&skip=0&schema=united_states_of_america&table=state_judicial_publications&order_by=created_at&filter_column=feed_title&filter_string=District%20Court%20Eastern%20District%20of%20California',
  title: 'District Court Eastern District of California',
  feedName: 'District Court Eastern District of California',
  branch: 'Judicial',
  topic: 'N/A',
  buttonName: 'Document',
  viewAllLink: '/us/judicial',
  showOnHomePage: false
},
{
  id: 'candDistrictCourt',
  type: 'normal',
  apiEndpoint: '&skip=0&schema=united_states_of_america&table=state_judicial_publications&order_by=created_at&filter_column=feed_title&filter_string=District%20Court%20Northern%20District%20of%20California',
  title: 'District Court Northern District of California',
  feedName: 'District Court Northern District of California',
  branch: 'Judicial',
  topic: 'N/A',
  buttonName: 'Document',
  viewAllLink: '/us/judicial',
  showOnHomePage: false
},
{
  id: 'casdDistrictCourt',
  type: 'normal',
  apiEndpoint: '&skip=0&schema=united_states_of_america&table=state_judicial_publications&order_by=created_at&filter_column=feed_title&filter_string=District%20Court%20Southern%20District%20of%20California',
  title: 'District Court Southern District of California',
  feedName: 'District Court Southern District of California',
  branch: 'Judicial',
  topic: 'N/A',
  buttonName: 'Document',
  viewAllLink: '/us/judicial',
  showOnHomePage: false
},
{
  id: 'codDistrictCourt',
  type: 'normal',
  apiEndpoint: '&skip=0&schema=united_states_of_america&table=state_judicial_publications&order_by=created_at&filter_column=feed_title&filter_string=District%20Court%20District%20of%20Colorado',
  title: 'District Court District of Colorado',
  feedName: 'District Court District of Colorado',
  branch: 'Judicial',
  topic: 'N/A',
  buttonName: 'Document',
  viewAllLink: '/us/judicial',
  showOnHomePage: false
},
{
  id: 'ctdDistrictCourt',
  type: 'normal',
  apiEndpoint: '&skip=0&schema=united_states_of_america&table=state_judicial_publications&order_by=created_at&filter_column=feed_title&filter_string=District%20Court%20District%20of%20Connecticut',
  title: 'District Court District of Connecticut',
  feedName: 'District Court District of Connecticut',
  branch: 'Judicial',
  topic: 'N/A',
  buttonName: 'Document',
  viewAllLink: '/us/judicial',
  showOnHomePage: false
},
{
  id: 'dcdDistrictCourt',
  type: 'normal',
  apiEndpoint: '&skip=0&schema=united_states_of_america&table=state_judicial_publications&order_by=created_at&filter_column=feed_title&filter_string=District%20Court%20District%20of%20Columbia',
  title: 'District Court District of Columbia',
  feedName: 'District Court District of Columbia',
  branch: 'Judicial',
  topic: 'N/A',
  buttonName: 'Document',
  viewAllLink: '/us/judicial',
  showOnHomePage: false
},
{
  id: 'dedDistrictCourt',
  type: 'normal',
  apiEndpoint: '&skip=0&schema=united_states_of_america&table=state_judicial_publications&order_by=created_at&filter_column=feed_title&filter_string=District%20Court%20District%20of%20Delaware',
  title: 'District Court District of Delaware',
  feedName: 'District Court District of Delaware',
  branch: 'Judicial',
  topic: 'N/A',
  buttonName: 'Document',
  viewAllLink: '/us/judicial',
  showOnHomePage: false
},
{
  id: 'flsdDistrictCourt',
  type: 'normal',
  apiEndpoint: '&skip=0&schema=united_states_of_america&table=state_judicial_publications&order_by=created_at&filter_column=feed_title&filter_string=District%20Court%20Southern%20District%20of%20Florida',
  title: 'District Court Southern District of Florida',
  feedName: 'District Court Southern District of Florida',
  branch: 'Judicial',
  topic: 'N/A',
  buttonName: 'Document',
  viewAllLink: '/us/judicial',
  showOnHomePage: false
},
{
  id: 'flndDistrictCourt',
  type: 'normal',
  apiEndpoint: '&skip=0&schema=united_states_of_america&table=state_judicial_publications&order_by=created_at&filter_column=feed_title&filter_string=District%20Court%20Northern%20District%20of%20Florida',
  title: 'District Court Northern District of Florida',
  feedName: 'District Court Northern District of Florida',
  branch: 'Judicial',
  topic: 'N/A',
  buttonName: 'Document',
  viewAllLink: '/us/judicial',
  showOnHomePage: false
},
{
  id: 'gamdDistrictCourt',
  type: 'normal',
  apiEndpoint: '&skip=0&schema=united_states_of_america&table=state_judicial_publications&order_by=created_at&filter_column=feed_title&filter_string=District%20Court%20Middle%20District%20of%20Georgia',
  title: 'District Court Middle District of Georgia',
  feedName: 'District Court Middle District of Georgia',
  branch: 'Judicial',
  topic: 'N/A',
  buttonName: 'Document',
  viewAllLink: '/us/judicial',
  showOnHomePage: false
},
{
  id: 'gandDistrictCourt',
  type: 'normal',
  apiEndpoint: '&skip=0&schema=united_states_of_america&table=state_judicial_publications&order_by=created_at&filter_column=feed_title&filter_string=District%20Court%20Northern%20District%20of%20Georgia',
  title: 'District Court Northern District of Georgia',
  feedName: 'District Court Northern District of Georgia',
  branch: 'Judicial',
  topic: 'N/A',
  buttonName: 'Document',
  viewAllLink: '/us/judicial',
  showOnHomePage: false
},
{
  id: 'gudDistrictCourt',
  type: 'normal',
  apiEndpoint: '&skip=0&schema=united_states_of_america&table=state_judicial_publications&order_by=created_at&filter_column=feed_title&filter_string=District%20Court%20District%20of%20Guam',
  title: 'District Court District of Guam',
  feedName: 'District Court District of Guam',
  branch: 'Judicial',
  topic: 'N/A',
  buttonName: 'Document',
  viewAllLink: '/us/judicial',
  showOnHomePage: false
},
{
  id: 'hidDistrictCourt',
  type: 'normal',
  apiEndpoint: '&skip=0&schema=united_states_of_america&table=state_judicial_publications&order_by=created_at&filter_column=feed_title&filter_string=District%20Court%20District%20of%20Hawaii',
  title: 'District Court District of Hawaii',
  feedName: 'District Court District of Hawaii',
  branch: 'Judicial',
  topic: 'N/A',
  buttonName: 'Document',
  viewAllLink: '/us/judicial',
  showOnHomePage: false
},
{
  id: 'iddDistrictCourt',
  type: 'normal',
  apiEndpoint: '&skip=0&schema=united_states_of_america&table=state_judicial_publications&order_by=created_at&filter_column=feed_title&filter_string=District%20Court%20District%20of%20Idaho',
  title: 'District Court District of Idaho',
  feedName: 'District Court District of Idaho',
  branch: 'Judicial',
  topic: 'N/A',
  buttonName: 'Document',
  viewAllLink: '/us/judicial',
  showOnHomePage: false
},
{
  id: 'ilndDistrictCourt',
  type: 'normal',
  apiEndpoint: '&skip=0&schema=united_states_of_america&table=state_judicial_publications&order_by=created_at&filter_column=feed_title&filter_string=District%20Court%20Northern%20District%20of%20Illinois',
  title: 'District Court Northern District of Illinois',
  feedName: 'District Court Northern District of Illinois',
  branch: 'Judicial',
  topic: 'N/A',
  buttonName: 'Document',
  viewAllLink: '/us/judicial',
  showOnHomePage: false
},
{
  id: 'ilsdDistrictCourt',
  type: 'normal',
  apiEndpoint: '&skip=0&schema=united_states_of_america&table=state_judicial_publications&order_by=created_at&filter_column=feed_title&filter_string=District%20Court%20Southern%20District%20of%20Illinois',
  title: 'District Court Southern District of Illinois',
  feedName: 'District Court Southern District of Illinois',
  branch: 'Judicial',
  topic: 'N/A',
  buttonName: 'Document',
  viewAllLink: '/us/judicial',
  showOnHomePage: false
},
{
  id: 'insdDistrictCourt',
  type: 'normal',
  apiEndpoint: '&skip=0&schema=united_states_of_america&table=state_judicial_publications&order_by=created_at&filter_column=feed_title&filter_string=District%20Court%20Southern%20District%20of%20Indiana',
  title: 'District Court Southern District of Indiana',
  feedName: 'District Court Southern District of Indiana',
  branch: 'Judicial',
  topic: 'N/A',
  buttonName: 'Document',
  viewAllLink: '/us/judicial',
  showOnHomePage: false
},
{
  id: 'iandDistrictCourt',
  type: 'normal',
  apiEndpoint: '&skip=0&schema=united_states_of_america&table=state_judicial_publications&order_by=created_at&filter_column=feed_title&filter_string=District%20Court%20Northern%20District%20of%20Iowa',
  title: 'District Court Northern District of Iowa',
  feedName: 'District Court Northern District of Iowa',
  branch: 'Judicial',
  topic: 'N/A',
  buttonName: 'Document',
  viewAllLink: '/us/judicial',
  showOnHomePage: false
},
{
  id: 'ksdDistrictCourt',
  type: 'normal',
  apiEndpoint: '&skip=0&schema=united_states_of_america&table=state_judicial_publications&order_by=created_at&filter_column=feed_title&filter_string=District%20Court%20District%20of%20Kansas',
  title: 'District Court District of Kansas',
  feedName: 'District Court District of Kansas',
  branch: 'Judicial',
  topic: 'N/A',
  buttonName: 'Document',
  viewAllLink: '/us/judicial',
  showOnHomePage: false
},
{
  id: 'kyedDistrictCourt',
  type: 'normal',
  apiEndpoint: '&skip=0&schema=united_states_of_america&table=state_judicial_publications&order_by=created_at&filter_column=feed_title&filter_string=District%20Court%20Eastern%20District%20of%20Kentucky',
  title: 'District Court Eastern District of Kentucky',
  feedName: 'District Court Eastern District of Kentucky',
  branch: 'Judicial',
  topic: 'N/A',
  buttonName: 'Document',
  viewAllLink: '/us/judicial',
  showOnHomePage: false
},
{
  id: 'kywdDistrictCourt',
  type: 'normal',
  apiEndpoint: '&skip=0&schema=united_states_of_america&table=state_judicial_publications&order_by=created_at&filter_column=feed_title&filter_string=District%20Court%20Western%20District%20of%20Kentucky',
  title: 'District Court Western District of Kentucky',
  feedName: 'District Court Western District of Kentucky',
  branch: 'Judicial',
  topic: 'N/A',
  buttonName: 'Document',
  viewAllLink: '/us/judicial',
  showOnHomePage: false
},
{
  id: 'laedDistrictCourt',
  type: 'normal',
  apiEndpoint: '&skip=0&schema=united_states_of_america&table=state_judicial_publications&order_by=created_at&filter_column=feed_title&filter_string=District%20Court%20Eastern%20District%20of%20Louisiana',
  title: 'District Court Eastern District of Louisiana',
  feedName: 'District Court Eastern District of Louisiana',
  branch: 'Judicial',
  topic: 'N/A',
  buttonName: 'Document',
  viewAllLink: '/us/judicial',
  showOnHomePage: false
},
{
  id: 'lamdDistrictCourt',
  type: 'normal',
  apiEndpoint: '&skip=0&schema=united_states_of_america&table=state_judicial_publications&order_by=created_at&filter_column=feed_title&filter_string=District%20Court%20Middle%20District%20of%20Louisiana',
  title: 'District Court Middle District of Louisiana',
  feedName: 'District Court Middle District of Louisiana',
  branch: 'Judicial',
  topic: 'N/A',
  buttonName: 'Document',
  viewAllLink: '/us/judicial',
  showOnHomePage: false
},
{
  id: 'medDistrictCourt',
  type: 'normal',
  apiEndpoint: '&skip=0&schema=united_states_of_america&table=state_judicial_publications&order_by=created_at&filter_column=feed_title&filter_string=District%20Court%20District%20of%20Maine',
  title: 'District Court District of Maine',
  feedName: 'District Court District of Maine',
  branch: 'Judicial',
  topic: 'N/A',
  buttonName: 'Document',
  viewAllLink: '/us/judicial',
  showOnHomePage: false
},
{
  id: 'mddDistrictCourt',
  type: 'normal',
  apiEndpoint: '&skip=0&schema=united_states_of_america&table=state_judicial_publications&order_by=created_at&filter_column=feed_title&filter_string=District%20Court%20District%20of%20Maryland',
  title: 'District Court District of Maryland',
  feedName: 'District Court District of Maryland',
  branch: 'Judicial',
  topic: 'N/A',
  buttonName: 'Document',
  viewAllLink: '/us/judicial',
  showOnHomePage: false
},
{
  id: 'madDistrictCourt',
  type: 'normal',
  apiEndpoint: '&skip=0&schema=united_states_of_america&table=state_judicial_publications&order_by=created_at&filter_column=feed_title&filter_string=District%20Court%20District%20of%20Massachusetts',
  title: 'District Court District of Massachusetts',
  feedName: 'District Court District of Massachusetts',
  branch: 'Judicial',
  topic: 'N/A',
  buttonName: 'Document',
  viewAllLink: '/us/judicial',
  showOnHomePage: false
},
{
  id: 'miedDistrictCourt',
  type: 'normal',
  apiEndpoint: '&skip=0&schema=united_states_of_america&table=state_judicial_publications&order_by=created_at&filter_column=feed_title&filter_string=District%20Court%20Eastern%20District%20of%20Michigan',
  title: 'District Court Eastern District of Michigan',
  feedName: 'District Court Eastern District of Michigan',
  branch: 'Judicial',
  topic: 'N/A',
  buttonName: 'Document',
  viewAllLink: '/us/judicial',
  showOnHomePage: false
},
{
  id: 'miwdDistrictCourt',
  type: 'normal',
  apiEndpoint: '&skip=0&schema=united_states_of_america&table=state_judicial_publications&order_by=created_at&filter_column=feed_title&filter_string=District%20Court%20Western%20District%20of%20Michigan',
  title: 'District Court Western District of Michigan',
  feedName: 'District Court Western District of Michigan',
  branch: 'Judicial',
  topic: 'N/A',
  buttonName: 'Document',
  viewAllLink: '/us/judicial',
  showOnHomePage: false
},
{
  id: 'mndDistrictCourt',
  type: 'normal',
  apiEndpoint: '&skip=0&schema=united_states_of_america&table=state_judicial_publications&order_by=created_at&filter_column=feed_title&filter_string=District%20Court%20District%20of%20Minnesota',
  title: 'District Court District of Minnesota',
  feedName: 'District Court District of Minnesota',
  branch: 'Judicial',
  topic: 'N/A',
  buttonName: 'Document',
  viewAllLink: '/us/judicial',
  showOnHomePage: false
},
{
  id: 'moedDistrictCourt',
  type: 'normal',
  apiEndpoint: '&skip=0&schema=united_states_of_america&table=state_judicial_publications&order_by=created_at&filter_column=feed_title&filter_string=District%20Court%20Eastern%20District%20of%20Missouri',
  title: 'District Court Eastern District of Missouri',
  feedName: 'District Court Eastern District of Missouri',
  branch: 'Judicial',
  topic: 'N/A',
  buttonName: 'Document',
  viewAllLink: '/us/judicial',
  showOnHomePage: false
},
{
  id: 'mowdDistrictCourt',
  type: 'normal',
  apiEndpoint: '&skip=0&schema=united_states_of_america&table=state_judicial_publications&order_by=created_at&filter_column=feed_title&filter_string=District%20Court%20Western%20District%20of%20Missouri',
  title: 'District Court Western District of Missouri',
  feedName: 'District Court Western District of Missouri',
  branch: 'Judicial',
  topic: 'N/A',
  buttonName: 'Document',
  viewAllLink: '/us/judicial',
  showOnHomePage: false
},
{
  id: 'mtdDistrictCourt',
  type: 'normal',
  apiEndpoint: '&skip=0&schema=united_states_of_america&table=state_judicial_publications&order_by=created_at&filter_column=feed_title&filter_string=District%20Court%20District%20of%20Montana',
  title: 'District Court District of Montana',
  feedName: 'District Court District of Montana',
  branch: 'Judicial',
  topic: 'N/A',
  buttonName: 'Document',
  viewAllLink: '/us/judicial',
  showOnHomePage: false
},
{
  id: 'nedDistrictCourt',
  type: 'normal',
  apiEndpoint: '&skip=0&schema=united_states_of_america&table=state_judicial_publications&order_by=created_at&filter_column=feed_title&filter_string=District%20Court%20District%20of%20Nebraska',
  title: 'District Court District of Nebraska',
  feedName: 'District Court District of Nebraska',
  branch: 'Judicial',
  topic: 'N/A',
  buttonName: 'Document',
  viewAllLink: '/us/judicial',
  showOnHomePage: false
},
{
  id: 'nhdDistrictCourt',
  type: 'normal',
  apiEndpoint: '&skip=0&schema=united_states_of_america&table=state_judicial_publications&order_by=created_at&filter_column=feed_title&filter_string=District%20Court%20District%20of%20New%20Hampshire',
  title: 'District Court District of New Hampshire',
  feedName: 'District Court District of New Hampshire',
  branch: 'Judicial',
  topic: 'N/A',
  buttonName: 'Document',
  viewAllLink: '/us/judicial',
  showOnHomePage: false
},
{
  id: 'njdDistrictCourt',
  type: 'normal',
  apiEndpoint: '&skip=0&schema=united_states_of_america&table=state_judicial_publications&order_by=created_at&filter_column=feed_title&filter_string=District%20Court%20District%20of%20New%20Jersey',
  title: 'District Court District of New Jersey',
  feedName: 'District Court District of New Jersey',
  branch: 'Judicial',
  topic: 'N/A',
  buttonName: 'Document',
  viewAllLink: '/us/judicial',
  showOnHomePage: false
},
{
  id: 'nmdDistrictCourt',
  type: 'normal',
  apiEndpoint: '&skip=0&schema=united_states_of_america&table=state_judicial_publications&order_by=created_at&filter_column=feed_title&filter_string=District%20Court%20District%20of%20New%20Mexico',
  title: 'District Court District of New Mexico',
  feedName: 'District Court District of New Mexico',
  branch: 'Judicial',
  topic: 'N/A',
  buttonName: 'Document',
  viewAllLink: '/us/judicial',
  showOnHomePage: false
},
{
  id: 'nyedDistrictCourt',
  type: 'normal',
  apiEndpoint: '&skip=0&schema=united_states_of_america&table=state_judicial_publications&order_by=created_at&filter_column=feed_title&filter_string=District%20Court%20Eastern%20District%20of%20New%20York',
  title: 'District Court Eastern District of New York',
  feedName: 'District Court Eastern District of New York',
  branch: 'Judicial',
  topic: 'N/A',
  buttonName: 'Document',
  viewAllLink: '/us/judicial',
  showOnHomePage: false
},
{
  id: 'nyndDistrictCourt',
  type: 'normal',
  apiEndpoint: '&skip=0&schema=united_states_of_america&table=state_judicial_publications&order_by=created_at&filter_column=feed_title&filter_string=District%20Court%20Northern%20District%20of%20New%20York',
  title: 'District Court Northern District of New York',
  feedName: 'District Court Northern District of New York',
  branch: 'Judicial',
  topic: 'N/A',
  buttonName: 'Document',
  viewAllLink: '/us/judicial',
  showOnHomePage: false
},
{
  id: 'ncmdDistrictCourt',
  type: 'normal',
  apiEndpoint: '&skip=0&schema=united_states_of_america&table=state_judicial_publications&order_by=created_at&filter_column=feed_title&filter_string=District%20Court%20Middle%20District%20of%20North%20Carolina',
  title: 'District Court Middle District of North Carolina',
  feedName: 'District Court Middle District of North Carolina',
  branch: 'Judicial',
  topic: 'N/A',
  buttonName: 'Document',
  viewAllLink: '/us/judicial',
  showOnHomePage: false
},
{
  id: 'nddDistrictCourt',
  type: 'normal',
  apiEndpoint: '&skip=0&schema=united_states_of_america&table=state_judicial_publications&order_by=created_at&filter_column=feed_title&filter_string=District%20Court%20District%20of%20North%20Dakota',
  title: 'District Court District of North Dakota',
  feedName: 'District Court District of North Dakota',
  branch: 'Judicial',
  topic: 'N/A',
  buttonName: 'Document',
  viewAllLink: '/us/judicial',
  showOnHomePage: false
},
{
  id: 'nmidDistrictCourt',
  type: 'normal',
  apiEndpoint: '&skip=0&schema=united_states_of_america&table=state_judicial_publications&order_by=created_at&filter_column=feed_title&filter_string=District%20Court%20District%20of%20Northern%20Mariana%20Islands',
  title: 'District Court District of Northern Mariana Islands',
  feedName: 'District Court District of Northern Mariana Islands',
  branch: 'Judicial',
  topic: 'N/A',
  buttonName: 'Document',
  viewAllLink: '/us/judicial',
  showOnHomePage: false
},
{
  id: 'ohndDistrictCourt',
  type: 'normal',
  apiEndpoint: '&skip=0&schema=united_states_of_america&table=state_judicial_publications&order_by=created_at&filter_column=feed_title&filter_string=District%20Court%20Northern%20District%20of%20Ohio',
  title: 'District Court Northern District of Ohio',
  feedName: 'District Court Northern District of Ohio',
  branch: 'Judicial',
  topic: 'N/A',
  buttonName: 'Document',
  viewAllLink: '/us/judicial',
  showOnHomePage: false
},
{
  id: 'ohsdDistrictCourt',
  type: 'normal',
  apiEndpoint: '&skip=0&schema=united_states_of_america&table=state_judicial_publications&order_by=created_at&filter_column=feed_title&filter_string=District%20Court%20Southern%20District%20of%20Ohio',
  title: 'District Court Southern District of Ohio',
  feedName: 'District Court Southern District of Ohio',
  branch: 'Judicial',
  topic: 'N/A',
  buttonName: 'Document',
  viewAllLink: '/us/judicial',
  showOnHomePage: false
},
{
  id: 'okedDistrictCourt',
  type: 'normal',
  apiEndpoint: '&skip=0&schema=united_states_of_america&table=state_judicial_publications&order_by=created_at&filter_column=feed_title&filter_string=District%20Court%20Eastern%20District%20of%20Oklahoma',
  title: 'District Court Eastern District of Oklahoma',
  feedName: 'District Court Eastern District of Oklahoma',
  branch: 'Judicial',
  topic: 'N/A',
  buttonName: 'Document',
  viewAllLink: '/us/judicial',
  showOnHomePage: false
 },
 {
  id: 'okwdDistrictCourt',
  type: 'normal',
  apiEndpoint: '&skip=0&schema=united_states_of_america&table=state_judicial_publications&order_by=created_at&filter_column=feed_title&filter_string=District%20Court%20Western%20District%20of%20Oklahoma',
  title: 'District Court Western District of Oklahoma',
  feedName: 'District Court Western District of Oklahoma',
  branch: 'Judicial',
  topic: 'N/A',
  buttonName: 'Document',
  viewAllLink: '/us/judicial',
  showOnHomePage: false
 },
 {
  id: 'ordDistrictCourt',
  type: 'normal',
  apiEndpoint: '&skip=0&schema=united_states_of_america&table=state_judicial_publications&order_by=created_at&filter_column=feed_title&filter_string=District%20Court%20District%20of%20Oregon',
  title: 'District Court District of Oregon',
  feedName: 'District Court District of Oregon',
  branch: 'Judicial',
  topic: 'N/A',
  buttonName: 'Document',
  viewAllLink: '/us/judicial',
  showOnHomePage: false
 },
 {
  id: 'paedDistrictCourt',
  type: 'normal',
  apiEndpoint: '&skip=0&schema=united_states_of_america&table=state_judicial_publications&order_by=created_at&filter_column=feed_title&filter_string=District%20Court%20Eastern%20District%20of%20Pennsylvania',
  title: 'District Court Eastern District of Pennsylvania',
  feedName: 'District Court Eastern District of Pennsylvania',
  branch: 'Judicial',
  topic: 'N/A',
  buttonName: 'Document',
  viewAllLink: '/us/judicial',
  showOnHomePage: false
 },
 {
  id: 'pamdDistrictCourt',
  type: 'normal',
  apiEndpoint: '&skip=0&schema=united_states_of_america&table=state_judicial_publications&order_by=created_at&filter_column=feed_title&filter_string=District%20Court%20Middle%20District%20of%20Pennsylvania',
  title: 'District Court Middle District of Pennsylvania',
  feedName: 'District Court Middle District of Pennsylvania',
  branch: 'Judicial',
  topic: 'N/A',
  buttonName: 'Document',
  viewAllLink: '/us/judicial',
  showOnHomePage: false
 },
 {
  id: 'pawdDistrictCourt',
  type: 'normal',
  apiEndpoint: '&skip=0&schema=united_states_of_america&table=state_judicial_publications&order_by=created_at&filter_column=feed_title&filter_string=District%20Court%20Western%20District%20of%20Pennsylvania',
  title: 'District Court Western District of Pennsylvania',
  feedName: 'District Court Western District of Pennsylvania',
  branch: 'Judicial',
  topic: 'N/A',
  buttonName: 'Document',
  viewAllLink: '/us/judicial',
  showOnHomePage: false
 },
 {
  id: 'prdDistrictCourt',
  type: 'normal',
  apiEndpoint: '&skip=0&schema=united_states_of_america&table=state_judicial_publications&order_by=created_at&filter_column=feed_title&filter_string=District%20Court%20District%20of%20Puerto%20Rico',
  title: 'District Court District of Puerto Rico',
  feedName: 'District Court District of Puerto Rico',
  branch: 'Judicial',
  topic: 'N/A',
  buttonName: 'Document',
  viewAllLink: '/us/judicial',
  showOnHomePage: false
 },
 {
  id: 'ridDistrictCourt',
  type: 'normal',
  apiEndpoint: '&skip=0&schema=united_states_of_america&table=state_judicial_publications&order_by=created_at&filter_column=feed_title&filter_string=District%20Court%20District%20of%20Rhode%20Island',
  title: 'District Court District of Rhode Island',
  feedName: 'District Court District of Rhode Island',
  branch: 'Judicial',
  topic: 'N/A',
  buttonName: 'Document',
  viewAllLink: '/us/judicial',
  showOnHomePage: false
 },
 {
  id: 'sddDistrictCourt',
  type: 'normal',
  apiEndpoint: '&skip=0&schema=united_states_of_america&table=state_judicial_publications&order_by=created_at&filter_column=feed_title&filter_string=District%20Court%20District%20of%20South%20Dakota',
  title: 'District Court District of South Dakota',
  feedName: 'District Court District of South Dakota',
  branch: 'Judicial',
  topic: 'N/A',
  buttonName: 'Document',
  viewAllLink: '/us/judicial',
  showOnHomePage: false
 },
 {
  id: 'tnedDistrictCourt',
  type: 'normal',
  apiEndpoint: '&skip=0&schema=united_states_of_america&table=state_judicial_publications&order_by=created_at&filter_column=feed_title&filter_string=District%20Court%20Eastern%20District%20of%20Tennessee',
  title: 'District Court Eastern District of Tennessee',
  feedName: 'District Court Eastern District of Tennessee',
  branch: 'Judicial',
  topic: 'N/A',
  buttonName: 'Document',
  viewAllLink: '/us/judicial',
  showOnHomePage: false
 },
 {
  id: 'tnwdDistrictCourt',
  type: 'normal',
  apiEndpoint: '&skip=0&schema=united_states_of_america&table=state_judicial_publications&order_by=created_at&filter_column=feed_title&filter_string=District%20Court%20Western%20District%20of%20Tennessee',
  title: 'District Court Western District of Tennessee',
  feedName: 'District Court Western District of Tennessee',
  branch: 'Judicial',
  topic: 'N/A',
  buttonName: 'Document',
  viewAllLink: '/us/judicial',
  showOnHomePage: false
 },
 {
  id: 'tnmdDistrictCourt',
  type: 'normal',
  apiEndpoint: '&skip=0&schema=united_states_of_america&table=state_judicial_publications&order_by=created_at&filter_column=feed_title&filter_string=District%20Court%20Middle%20District%20of%20Tennessee',
  title: 'District Court Middle District of Tennessee',
  feedName: 'District Court Middle District of Tennessee',
  branch: 'Judicial',
  topic: 'N/A',
  buttonName: 'Document',
  viewAllLink: '/us/judicial',
  showOnHomePage: false
 },
 {
  id: 'txndDistrictCourt',
  type: 'normal',
  apiEndpoint: '&skip=0&schema=united_states_of_america&table=state_judicial_publications&order_by=created_at&filter_column=feed_title&filter_string=District%20Court%20Northern%20District%20of%20Texas',
  title: 'District Court Northern District of Texas',
  feedName: 'District Court Northern District of Texas',
  branch: 'Judicial',
  topic: 'N/A',
  buttonName: 'Document',
  viewAllLink: '/us/judicial',
  showOnHomePage: false
 },
 {
  id: 'txsdDistrictCourt',
  type: 'normal',
  apiEndpoint: '&skip=0&schema=united_states_of_america&table=state_judicial_publications&order_by=created_at&filter_column=feed_title&filter_string=District%20Court%20Southern%20District%20of%20Texas',
  title: 'District Court Southern District of Texas',
  feedName: 'District Court Southern District of Texas',
  branch: 'Judicial',
  topic: 'N/A',
  buttonName: 'Document',
  viewAllLink: '/us/judicial',
  showOnHomePage: false
 },
 {
  id: 'txwdDistrictCourt',
  type: 'normal',
  apiEndpoint: '&skip=0&schema=united_states_of_america&table=state_judicial_publications&order_by=created_at&filter_column=feed_title&filter_string=District%20Court%20Western%20District%20of%20Texas',
  title: 'District Court Western District of Texas',
  feedName: 'District Court Western District of Texas',
  branch: 'Judicial',
  topic: 'N/A',
  buttonName: 'Document',
  viewAllLink: '/us/judicial',
  showOnHomePage: false
 },
 {
  id: 'utdDistrictCourt',
  type: 'normal',
  apiEndpoint: '&skip=0&schema=united_states_of_america&table=state_judicial_publications&order_by=created_at&filter_column=feed_title&filter_string=District%20Court%20District%20of%20Utah',
  title: 'District Court District of Utah',
  feedName: 'District Court District of Utah',
  branch: 'Judicial',
  topic: 'N/A',
  buttonName: 'Document',
  viewAllLink: '/us/judicial',
  showOnHomePage: false
 },
 {
  id: 'vtdDistrictCourt',
  type: 'normal',
  apiEndpoint: '&skip=0&schema=united_states_of_america&table=state_judicial_publications&order_by=created_at&filter_column=feed_title&filter_string=District%20Court%20District%20of%20Vermont',
  title: 'District Court District of Vermont',
  feedName: 'District Court District of Vermont',
  branch: 'Judicial',
  topic: 'N/A',
  buttonName: 'Document',
  viewAllLink: '/us/judicial',
  showOnHomePage: false
 },
 {
  id: 'waedDistrictCourt',
  type: 'normal',
  apiEndpoint: '&skip=0&schema=united_states_of_america&table=state_judicial_publications&order_by=created_at&filter_column=feed_title&filter_string=District%20Court%20Eastern%20District%20of%20Washington',
  title: 'District Court Eastern District of Washington',
  feedName: 'District Court Eastern District of Washington',
  branch: 'Judicial',
  topic: 'N/A',
  buttonName: 'Document',
  viewAllLink: '/us/judicial',
  showOnHomePage: false
 },
 {
  id: 'wvndDistrictCourt',
  type: 'normal',
  apiEndpoint: '&skip=0&schema=united_states_of_america&table=state_judicial_publications&order_by=created_at&filter_column=feed_title&filter_string=District%20Court%20Northern%20District%20of%20West%20Virginia',
  title: 'District Court Northern District of West Virginia',
  feedName: 'District Court Northern District of West Virginia',
  branch: 'Judicial',
  topic: 'N/A',
  buttonName: 'Document',
  viewAllLink: '/us/judicial',
  showOnHomePage: false
 },
 {
  id: 'wydDistrictCourt',
  type: 'normal',
  apiEndpoint: '&skip=0&schema=united_states_of_america&table=state_judicial_publications&order_by=created_at&filter_column=feed_title&filter_string=District%20Court%20District%20of%20Wyoming',
  title: 'District Court District of Wyoming',
  feedName: 'District Court District of Wyoming',
  branch: 'Judicial',
  topic: 'N/A',
  buttonName: 'Document',
  viewAllLink: '/us/judicial',
  showOnHomePage: false
 }
  ],

  defense: [
    {
      id: 'defenseDepartmentNews',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=defense&order_by=created_at',
      title: 'Department of Defense News',
      feedName: 'Department of Defense News',
      branch: 'Executive',
      topic: 'Defense',
      buttonName: '',
      viewAllLink: '/us/defense',
      showOnHomePage: true
    },
    {
      id: 'defenseDepartmentDocuments',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=defense&order_by=created_at&filter_column=agency&filter_string=Defense%20Department',
      title: 'Department of Defense Documents',
      feedName: 'Department of Defense Documents',
      branch: 'Executive',
      topic: 'Foreign Affairs',
      buttonName: 'Document',
      viewAllLink: '/us/defense',
      showOnHomePage: false
    },
    {
      id: 'armyDocuments',
      type: 'normal',
      apiEndpoint: '&table_name=defense&agency=Army%20Department',
      title: 'Army Documents',
      feedName: 'Army Documents',
      branch: 'Executive',
      topic: 'N/A',
      buttonName: '',
      viewAllLink: '/us/defense',
      showOnHomePage: false
    },
    {
      id: 'navyDocuments',
      type: 'normal',
      apiEndpoint: '&table_name=defense&agency=Navy%20Department',
      title: 'Navy Documents',
      feedName: 'Navy Documents',
      branch: 'Executive',
      topic: 'N/A',
      buttonName: '',
      viewAllLink: '/us/defense',
      showOnHomePage: false
    },
    {
      id: 'airForceDocuments',
      type: 'normal',
      apiEndpoint: '&table_name=defense&agency=Air%20Force%20Department',
      title: 'Air Force Documents',
      feedName: 'Air Force Documents',
      branch: 'Executive',
      topic: 'N/A',
      buttonName: '',
      viewAllLink: '/us/defense',
      showOnHomePage: false
    },
    {
      id: 'defenseAcquisition',
      type: 'normal',
      apiEndpoint: '&table_name=defense&agency=Defense%20Acquisition%20Regulations%20System',
      title: 'Defense Acquisition Regulations System',
      feedName: 'Defense Acquisition Regulations System',
      branch: 'Executive',
      topic: 'Defense',
      buttonName: 'Doc',
      viewAllLink: '/us/defense',
      showOnHomePage: false
    },
    {
      id: 'defenseContract',
      type: 'normal',
      apiEndpoint: '&table_name=defense&agency=Defense%20Contract%20Audit%20Agency',
      title: 'Defense Contract Audit Agency',
      feedName: 'Defense Contract Audit Agency',
      branch: 'Executive',
      topic: 'Defense',
      buttonName: 'Doc',
      viewAllLink: '/us/defense',
      showOnHomePage: false
    },
    {
      id: 'disaDocuments',
      type: 'normal',
      apiEndpoint: '&table_name=defense&agency=Defense%20Information%20Systems%20Agency',
      title: 'Defense Information Systems Agency',
      feedName: 'Defense Information Systems Agency',
      branch: 'Executive',
      topic: 'Defense',
      buttonName: 'Doc',
      viewAllLink: '/us/defense',
      showOnHomePage: false
    },
    {
      id: 'diaDocuments',
      type: 'normal',
      apiEndpoint: '&table_name=defense&agency=Defense%20Intelligence%20Agency',
      title: 'Defense Intelligence Agency',
      feedName: 'Defense Intelligence Agency',
      branch: 'Executive',
      topic: 'Defense',
      buttonName: 'Doc',
      viewAllLink: '/us/defense',
      showOnHomePage: false
    },
    {
      id: 'dlaDocuments',
      type: 'normal',
      apiEndpoint: '&table_name=defense&agency=Defense%20Logistics%20Agency',
      title: 'Defense Logistics Agency',
      feedName: 'Defense Logistics Agency',
      branch: 'Executive',
      topic: 'Defense',
      buttonName: 'Doc',
      viewAllLink: '/us/defense',
      showOnHomePage: false
    },
    {
      id: 'engineersCorps',
      type: 'normal',
      apiEndpoint: '&table_name=defense&agency=Engineers%20Corps',
      title: 'Engineers Corps',
      feedName: 'Engineers Corps',
      branch: 'Executive',
      topic: 'Defense',
      buttonName: 'Doc',
      viewAllLink: '/us/defense',
      showOnHomePage: false
    },
    {
      id: 'armedServicesMaterials',
      type: 'normal',
      apiEndpoint: '&skip=0&committee=Committee%20on%20Armed%20Services&chamber=HOUSE',
      title: 'Committee on Armed Services Materials',
      feedName: 'Committee on Armed Services Materials',
      branch: 'Legislative',
      topic: 'N/A',
      buttonName: 'Bill',
      viewAllLink: '/us/defense',
      showOnHomePage: false,
      useCommitteeAPI: true 
    },
   ],
   
   elections: [
    {
      id: 'federalElectionCommission',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=federal_election_commission&order_by=created_at',
      title: 'Federal Election Commission',
      feedName: 'Federal Election Commission',
      branch: 'N/A',
      topic: 'Elections',
      buttonName: 'Doc',
      viewAllLink: '/us/elections'
    },
    {
      id: 'electionAssistanceCommission',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=election_assistance_commission&order_by=created_at',
      title: 'Election Assistance Commission',
      feedName: 'Election Assistance Commission',
      branch: 'Legislative',
      topic: 'N/A',
      buttonName: 'Doc',
      viewAllLink: '/us/elections'
    }
   ],
   economy: [
    {
      id: 'gdpUpdates',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=gdp&order_by=created_at',
      title: 'GDP Updates',
      feedName: 'GDP Updates',
      branch: 'Executive',
      topic: 'Economy',
      buttonName: 'Document',
      viewAllLink: '/us/economy',
      showOnHomePage: true
    },
    {
      id: 'inflationUpdates',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=inflation_updates&order_by=created_at',
      title: 'Inflation Updates',
      feedName: 'Inflation Updates',
      branch: 'Executive',
      topic: 'Economy',
      buttonName: 'Document',
      viewAllLink: '/us/economy',
      showOnHomePage: true
    },
    {
      id: 'wageGrowth',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=wage_growth&order_by=created_at',
      title: 'Wage Growth',
      feedName: 'Wage Growth',
      branch: 'Executive',
      topic: 'Economy',
      buttonName: 'Document',
      viewAllLink: '/us/economy',
      showOnHomePage: true
    },
    {
      id: 'secPressReleases',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=sec_updates&order_by=created_at',
      title: 'SEC Press Releases',
      feedName: 'SEC Press Releases',
      branch: 'Executive',
      topic: 'Economy',
      buttonName: 'Document',
      viewAllLink: '/us/economy',
      showOnHomePage: true
    },
    {
      id: 'secSpeechesStatements',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=sec_speeches_statements&order_by=created_at',
      title: 'SEC Speeches and Statements',
      feedName: 'SEC Speeches and Statements',
      branch: 'Executive',
      topic: 'Economy',
      buttonName: 'Document',
      viewAllLink: '/us/economy',
      showOnHomePage: false
    },
    {
      id: 'federalReserveSpeeches',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=federal_reserve&order_by=created_at&filter_column=media_type&filter_string=Speeches%20%26%20Testimony',
      title: 'Federal Reserve Speeches & Testimony',
      feedName: 'Federal Reserve Speeches & Testimony',
      branch: 'Executive',
      topic: 'Economy',
      buttonName: 'Doc',
      viewAllLink: '/us/economy',
      showOnHomePage: false
    },
    {
      id: 'federalReserveResearchPapers',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=federal_reserve&order_by=created_at&filter_column=media_type&filter_string=Research%20Paper%20Feeds',
      title: 'Federal Reserve Research Papers',
      feedName: 'Federal Reserve Research Papers',
      branch: 'Executive',
      topic: 'Economy',
      buttonName: 'Doc',
      viewAllLink: '/us/economy',
      showOnHomePage: false
    },
    {
      id: 'federalReserveOthers',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=federal_reserve&order_by=created_at&filter_column=media_type&filter_string=Other',
      title: 'Federal Reserve Others',
      feedName: 'Federal Reserve Others',
      branch: 'Executive',
      topic: 'Economy',
      buttonName: 'Doc',
      viewAllLink: '/us/economy',
      showOnHomePage: false
    },
    {
      id: 'federalReserveAnnouncements',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=federal_reserve&order_by=created_at&filter_column=media_type&filter_string=Announcements',
      title: 'Federal Reserve Announcements',
      feedName: 'Federal Reserve Announcements',
      branch: 'Executive',
      topic: 'Economy',
      buttonName: 'Doc',
      viewAllLink: '/us/economy',
      showOnHomePage: false
    },
    {
      id: 'commerceNews',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=commerce&order_by=created_at',
      title: 'Department of Commerce News',
      feedName: 'Department of Commerce News',
      branch: 'Executive',
      topic: 'Economy',
      buttonName: '',
      viewAllLink: '/us/economy',
      showOnHomePage: false
    },
    {
      id: 'commerceDocuments',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=commerce&order_by=created_at&filter_column=agency&filter_string=Commerce%20Department',
      title: 'Department of Commerce Documents',
      feedName: 'Department of Commerce Documents',
      branch: 'Executive',
      topic: 'N/A',
      buttonName: '',
      viewAllLink: '/us/economy',
      showOnHomePage: false
    },
    {
      id: 'financialServicesCommittee',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=committee_on_financial_services_meeting_feed&order_by=created_at',
      title: 'House Committee on Financial Services',
      feedName: 'House Committee on Financial Services',
      branch: 'Legislative',
      topic: 'Economy',
      buttonName: '',
      viewAllLink: '/us/economy',
      showOnHomePage: false
    },
    {
      id: 'financialServicesMaterials',
      type: 'normal',
      apiEndpoint: '&skip=0&committee=Committee%20on%20Financial%20Services&chamber=HOUSE',
      title: 'Committee on Financial Services Materials',
      feedName: 'Committee on Financial Services Materials',
      branch: 'Legislative',
      topic: 'N/A',
      buttonName: 'Bill',
      viewAllLink: '/us/economy',
      showOnHomePage: false,
      useCommitteeAPI: true 
    },
    {
      id: 'treasuryNews',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=treasury&order_by=created_at',
      title: 'Department of Treasury News',
      feedName: 'Department of Treasury News',
      branch: 'Executive',
      topic: 'Economy',
      buttonName: '',
      viewAllLink: '/us/economy',
      showOnHomePage: false
    },
    {
      id: 'treasuryDocuments',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=treasury&order_by=created_at&filter_column=agency&filter_string=Treasury%20Department',
      title: 'Department of Treasury Documents',
      feedName: 'Department of Treasury Documents',
      branch: 'Executive',
      topic: 'N/A',
      buttonName: '',
      viewAllLink: '/us/economy',
      showOnHomePage: false
    },
    {
      id: 'laborNews',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=labor&order_by=created_at',
      title: 'Department of Labor News',
      feedName: 'Department of Labor News',
      branch: 'Executive',
      topic: 'Economy',
      buttonName: '',
      viewAllLink: '/us/economy',
      showOnHomePage: false
    },
    {
      id: 'laborDocuments',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=labor&order_by=created_at&filter_column=agency&filter_string=Labor%20Department',
      title: 'Department of Labor Documents',
      feedName: 'Department of Labor Documents',
      branch: 'Executive',
      topic: 'N/A',
      buttonName: '',
      viewAllLink: '/us/economy',
      showOnHomePage: false
    },
    {
      id: 'economicAnalysisBureauDocuments',
      type: 'normal',
      apiEndpoint: '&table_name=commerce&agency=Economic%20Analysis%20Bureau',
      title: 'Economic Analysis Bureau Documents',
      feedName: 'Economic Analysis Bureau Documents',
      branch: 'Executive',
      topic: 'Commerce',
      buttonName: 'Doc',
      viewAllLink: '/us/economy',
      showOnHomePage: false
    },
    {
      id: 'censusDocuments',
      type: 'normal',
      apiEndpoint: '&table_name=commerce&agency=Census%20Bureau',
      title: 'Census Bureau Documents',
      feedName: 'Census Bureau Documents',
      branch: 'Executive',
      topic: 'Commerce',
      buttonName: 'Doc',
      viewAllLink: '/us/economy',
      showOnHomePage: false
    },
    {
      id: 'minorityBusinessDocuments',
      type: 'normal',
      apiEndpoint: '&table_name=commerce&agency=Minority%20Business%20Development%20Agency',
      title: 'Minority Business Development Agency Documents',
      feedName: 'Minority Business Development Agency Documents',
      branch: 'Executive',
      topic: 'Commerce',
      buttonName: 'Doc',
      viewAllLink: '/us/economy',
      showOnHomePage: false
    },
    {
      id: 'nistDocuments',
      type: 'normal',
      apiEndpoint: '&table_name=commerce&agency=National%20Institute%20of%20Standards%20and%20Technology',
      title: 'National Institute of Standards and Technology Documents',
      feedName: 'National Institute of Standards and Technology Documents',
      branch: 'Executive',
      topic: 'Commerce',
      buttonName: 'Doc',
      viewAllLink: '/us/economy',
      showOnHomePage: false
    },
    {
      id: 'noaaDocuments',
      type: 'normal',
      apiEndpoint: '&table_name=commerce&agency=National%20Oceanic%20and%20Atmospheric%20Administration',
      title: 'National Oceanic and Atmospheric Administration Documents',
      feedName: 'National Oceanic and Atmospheric Administration Documents',
      branch: 'Executive',
      topic: 'Commerce',
      buttonName: 'Doc',
      viewAllLink: '/us/economy',
      showOnHomePage: false
    },
    {
      id: 'ntisDocuments',
      type: 'normal',
      apiEndpoint: '&table_name=commerce&agency=National%20Technical%20Information%20Service',
      title: 'National Technical Information Service Documents',
      feedName: 'National Technical Information Service Documents',
      branch: 'Executive',
      topic: 'Commerce',
      buttonName: 'Doc',
      viewAllLink: '/us/economy',
      showOnHomePage: false
    },
    {
      id: 'patentTrademarkDocuments',
      type: 'normal',
      apiEndpoint: '&table_name=commerce&agency=Patent%20and%20Trademark%20Office',
      title: 'Patent and Trademark Office Documents',
      feedName: 'Patent and Trademark Office Documents',
      branch: 'Executive',
      topic: 'Commerce',
      buttonName: 'Doc',
      viewAllLink: '/us/economy',
      showOnHomePage: false
    },
    {
      id: 'fiscalServiceDocuments',
      type: 'normal',
      apiEndpoint: '&table_name=treasury&agency=Bureau%20of%20the%20Fiscal%20Service',
      title: 'Bureau of the Fiscal Service Documents',
      feedName: 'Bureau of the Fiscal Service Documents',
      branch: 'Executive',
      topic: 'Economy',
      buttonName: 'Doc',
      viewAllLink: '/us/economy',
      showOnHomePage: false
    },
    {
      id: 'finCenDocuments',
      type: 'normal',
      apiEndpoint: '&table_name=treasury&agency=Financial%20Crimes%20Enforcement%20Network',
      title: 'Financial Crimes Enforcement Network Documents',
      feedName: 'Financial Crimes Enforcement Network Documents',
      branch: 'Executive',
      topic: 'Economy',
      buttonName: 'Doc',
      viewAllLink: '/us/economy',
      showOnHomePage: false
    },
    {
      id: 'economicsStatistics',
      type: 'normal',
      apiEndpoint: '&table_name=commerce&agency=Economics%20and%20Statistics%20Administration',
      title: 'Economics and Statistics Administration Documents',
      feedName: 'Economics and Statistics Administration Documents',
      branch: 'Executive',
      topic: 'Commerce',
      buttonName: 'Doc',
      viewAllLink: '/us/economy',
      showOnHomePage: false
    },
    {
      id: 'foreignAssetsControl',
      type: 'normal',
      apiEndpoint: '&table_name=treasury&agency=Foreign%20Assets%20Control%20Office',
      title: 'Foreign Assets Control Office Documents',
      feedName: 'Foreign Assets Control Office Documents',
      branch: 'Executive',
      topic: 'Economy',
      buttonName: 'Doc',
      viewAllLink: '/us/economy',
      showOnHomePage: false
    },
    {
      id: 'irs',
      type: 'normal',
      apiEndpoint: '&table_name=treasury&agency=Internal%20Revenue%20Service',
      title: 'Internal Revenue Service Documents',
      feedName: 'Internal Revenue Service Documents',
      branch: 'Executive',
      topic: 'Economy',
      buttonName: 'Doc',
      viewAllLink: '/us/economy',
      showOnHomePage: false
    },
    {
      id: 'internationalInvestment',
      type: 'normal',
      apiEndpoint: '&table_name=treasury&agency=International%20Investment%20Office',
      title: 'International Investment Office Documents',
      feedName: 'International Investment Office Documents',
      branch: 'Executive',
      topic: 'Economy',
      buttonName: 'Doc',
      viewAllLink: '/us/economy',
      showOnHomePage: false
    },
    {
      id: 'publicDebt',
      type: 'normal',
      apiEndpoint: '&table_name=treasury&agency=Public%20Debt%20Bureau',
      title: 'Public Debt Bureau Documents',
      feedName: 'Public Debt Bureau Documents',
      branch: 'Executive',
      topic: 'Economy',
      buttonName: 'Doc',
      viewAllLink: '/us/economy',
      showOnHomePage: false
    },
    {
      id: 'thriftSupervision',
      type: 'normal',
      apiEndpoint: '&table_name=treasury&agency=Thrift%20Supervision%20Office',
      title: 'Thrift Supervision Office Documents',
      feedName: 'Thrift Supervision Office Documents',
      branch: 'Executive',
      topic: 'Economy',
      buttonName: 'Doc',
      viewAllLink: '/us/economy',
      showOnHomePage: false
    },
    {
      id: 'veteransEmployment',
      type: 'normal',
      apiEndpoint: '&table_name=labor&agency=Veterans%20Employment%20and%20Training%20Service',
      title: 'Veterans Employment and Training Service Documents',
      feedName: 'Veterans Employment and Training Service Documents',
      branch: 'Executive',
      topic: 'Economy',
      buttonName: 'Doc',
      viewAllLink: '/us/economy',
      showOnHomePage: false
    },
    {
      id: 'councilOfEconomicAdvisers',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=council_of_economic_advisers&order_by=created_at',
      title: 'Council of Economic Advisers',
      feedName: 'Council of Economic Advisers',
      branch: 'Executive',
      topic: 'N/A',
      buttonName: 'Document',
      viewAllLink: '/us/economy',
      showOnHomePage: false
    },
    {
      id: 'nationalEconomicCouncil',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=national_economic_council&order_by=created_at',
      title: 'National Economic Council',
      feedName: 'National Economic Council',
      branch: 'Executive',
      topic: 'N/A',
      buttonName: 'Document',
      viewAllLink: '/us/economy',
      showOnHomePage: false
    },
    {
      id: 'exportAdministration',
      type: 'normal',
      apiEndpoint: '&table_name=commerce&agency=Export%20Administration%20Bureau',
      title: 'Export Administration Bureau Documents',
      feedName: 'Export Administration Bureau Documents',
      branch: 'Executive',
      topic: 'Commerce',
      buttonName: 'Doc',
      viewAllLink: '/us/economy',
      showOnHomePage: false
    },
    {
      id: 'monetaryOffices',
      type: 'normal',
      apiEndpoint: '&table_name=treasury&agency=Monetary%20Offices',
      title: 'Monetary Offices Documents',
      feedName: 'Monetary Offices Documents',
      branch: 'Executive',
      topic: 'Economy',
      buttonName: 'Doc',
      viewAllLink: '/us/economy',
      showOnHomePage: false
    },
    {
      id: 'travelTourism',
      type: 'normal',
      apiEndpoint: '&table_name=commerce&agency=Travel%20and%20Tourism%20Administration',
      title: 'Travel and Tourism Administration Documents',
      feedName: 'Travel and Tourism Administration Documents',
      branch: 'Executive',
      topic: 'Commerce',
      buttonName: 'Doc',
      viewAllLink: '/us/economy',
      showOnHomePage: false
    }
  ],
  environment: [
    {
      id: 'epa',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=epa&order_by=created_at',
      title: 'EPA',
      feedName: 'EPA',
      branch: 'N/A',
      topic: 'Environment',
      buttonName: 'Document',
      viewAllLink: '/us/environment',
      showOnHomePage: true
    },
    {
      id: 'nationalWeatherServiceUpdate',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=national_weather_service_update&order_by=created_at',
      title: 'National Weather Service Update',
      feedName: 'National Weather Service Update',
      branch: 'N/A',
      topic: 'Environment',
      buttonName: 'Document',
      viewAllLink: '/us/environment',
      showOnHomePage: true
    },
    {
      id: 'nationalWeatherServicePredictions',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=national_weather_service_predictions&order_by=created_at',
      title: 'National Weather Service Predictions',
      feedName: 'National Weather Service Predictions',
      branch: 'N/A',
      topic: 'Environment',
      buttonName: 'Document',
      viewAllLink: '/us/environment',
      showOnHomePage: true
    },
    {
      id: 'noaaNews',
      type: 'normal',
      apiEndpoint: '&table_name=commerce&agency=National%20Oceanic%20and%20Atmospheric%20Administration',
      title: 'National Oceanic and Atmospheric Administration',
      feedName: 'National Oceanic and Atmospheric Administration',
      branch: 'Executive',
      topic: 'Environment',
      buttonName: 'Document',
      viewAllLink: '/us/environment',
      showOnHomePage: true
    },
    {
      id: 'nationalScienceFoundation',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=national_science_foundation&order_by=created_at',
      title: 'National Science Foundation Research News',
      feedName: 'National Science Foundation Research News',
      branch: 'Executive',
      topic: 'Environment',
      buttonName: '',
      viewAllLink: '/us/environment',
      showOnHomePage: false
    },
    {
      id: 'nasa',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=nasa&order_by=created_at',
      title: 'NASA',
      feedName: 'NASA',
      branch: 'Executive',
      topic: 'Environment',
      buttonName: '',
      viewAllLink: '/us/environment',
      showOnHomePage: false
    },
    {
      id: 'interiorNews',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=interior&order_by=created_at',
      title: 'Department of the Interior News',
      feedName: 'Department of the Interior News',
      branch: 'Executive',
      topic: 'N/A',
      buttonName: 'Document',
      viewAllLink: '/us/environment',
      showOnHomePage: false
    },
    {
      id: 'interiorDocuments',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=interior&order_by=created_at&filter_column=agency&filter_string=Interior%20Department',
      title: 'Department of the Interior Documents',
      feedName: 'Department of the Interior Documents',
      branch: 'Executive',
      topic: 'N/A',
      buttonName: '',
      viewAllLink: '/us/environment',
      showOnHomePage: false
    },
    {
      id: 'agricultureNews',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=environment&order_by=created_at',
      title: 'Department of Agriculture News',
      feedName: 'Department of Agriculture News',
      branch: 'Executive',
      topic: 'Environment',
      buttonName: '',
      viewAllLink: '/us/environment',
      showOnHomePage: false
    },
    {
      id: 'agricultureDocuments',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=environment&order_by=created_at&filter_column=agency&filter_string=Department%20of%20Agriculture',
      title: 'Department of Agriculture Documents',
      feedName: 'Department of Agriculture Documents',
      branch: 'Executive',
      topic: 'N/A',
      buttonName: '',
      viewAllLink: '/us/environment',
      showOnHomePage: false
    },
    {
      id: 'housingNews',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=housing_and_urban_development&order_by=created_at',
      title: 'Department of Housing and Urban Development',
      feedName: 'Department of Housing and Urban Development',
      branch: 'Executive',
      topic: 'N/A',
      buttonName: 'Document',
      viewAllLink: '/us/environment',
      showOnHomePage: false
    },
    {
      id: 'nationalParkService',
      type: 'normal',
      apiEndpoint: '&table_name=interior&agency=National%20Park%20Service',
      title: 'National Park Service',
      feedName: 'National Park Service',
      branch: 'Executive',
      topic: 'Environment',
      buttonName: 'Doc',
      viewAllLink: '/us/environment',
      showOnHomePage: false
    },
    {
      id: 'naturalResourcesRevenue',
      type: 'normal',
      apiEndpoint: '&table_name=interior&agency=Natural%20Resources%20Revenue%20Office',
      title: 'Natural Resources Revenue Office Documents',
      feedName: 'Natural Resources Revenue Office Documents',
      branch: 'Executive',
      topic: 'Environment',
      buttonName: 'Doc',
      viewAllLink: '/us/environment',
      showOnHomePage: false
    },
    {
      id: 'oceanEnergyManagement',
      type: 'normal',
      apiEndpoint: '&table_name=interior&agency=Ocean%20Energy%20Management%20Bureau',
      title: 'Ocean Energy Management Bureau Documents',
      feedName: 'Ocean Energy Management Bureau Documents',
      branch: 'Executive',
      topic: 'Environment',
      buttonName: 'Doc',
      viewAllLink: '/us/environment',
      showOnHomePage: false
    },
    {
      id: 'oceanEnergyRegulation',
      type: 'normal',
      apiEndpoint: '&table_name=interior&agency=Ocean%20Energy%20Management%2C%20Regulation%2C%20and%20Enforcement%20Bureau',
      title: 'Ocean Energy Management, Regulation, and Enforcement Bureau Documents',
      feedName: 'Ocean Energy Management, Regulation, and Enforcement Bureau Documents',
      branch: 'Executive',
      topic: 'Environment',
      buttonName: 'Doc',
      viewAllLink: '/us/environment',
      showOnHomePage: false
    },
    {
      id: 'reclamationBureau',
      type: 'normal',
      apiEndpoint: '&table_name=interior&agency=Reclamation%20Bureau',
      title: 'Reclamation Bureau Documents',
      feedName: 'Reclamation Bureau Documents',
      branch: 'Executive',
      topic: 'Environment',
      buttonName: 'Doc',
      viewAllLink: '/us/environment',
      showOnHomePage: false
    },
    {
      id: 'safetyEnvironmentEnforcement',
      type: 'normal',
      apiEndpoint: '&table_name=interior&agency=Safety%20and%20Environmental%20Enforcement%20Bureau',
      title: 'Safety and Environmental Enforcement Bureau Documents',
      feedName: 'Safety and Environmental Enforcement Bureau Documents',
      branch: 'Executive',
      topic: 'Environment',
      buttonName: 'Doc',
      viewAllLink: '/us/environment',
      showOnHomePage: false
    },
    {
      id: 'surfaceMining',
      type: 'normal',
      apiEndpoint: '&table_name=interior&agency=Surface%20Mining%20Reclamation%20and%20Enforcement%20Office',
      title: 'Surface Mining Reclamation and Enforcement Office Documents',
      feedName: 'Surface Mining Reclamation and Enforcement Office Documents',
      branch: 'Executive',
      topic: 'Environment',
      buttonName: 'Doc',
      viewAllLink: '/us/environment',
      showOnHomePage: false
    },
    {
      id: 'housingOversight',
      type: 'normal',
      apiEndpoint: '&table_name=hud&agency=Federal%20Housing%20Enterprise%20Oversight%20Office',
      title: 'Federal Housing Enterprise Oversight Office Documents',
      feedName: 'Federal Housing Enterprise Oversight Office Documents',
      branch: 'Executive',
      topic: 'Housing',
      buttonName: 'Doc',
      viewAllLink: '/us/environment',
      showOnHomePage: false
    },
    {
      id: 'gnma',
      type: 'normal',
      apiEndpoint: '&table_name=hud&agency=Government%20National%20Mortgage%20Association',
      title: 'Government National Mortgage Association Documents',
      feedName: 'Government National Mortgage Association Documents',
      branch: 'Executive',
      topic: 'Housing',
      buttonName: 'Doc',
      viewAllLink: '/us/environment',
      showOnHomePage: false
    }
  ],
  foreignAffairs: [
    {
      id: 'stateNews',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=state&order_by=created_at',
      title: 'Department of State News',
      feedName: 'Department of State News',
      branch: 'Executive',
      topic: 'N/A',
      buttonName: '',
      viewAllLink: '/us/foreignaffairs',
      showOnHomePage: true
    },
    {
      id: 'stateDocuments',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=state&order_by=created_at&filter_column=collection_name&filter_string=Department%20of%20State%20Documents',
      title: 'Department of State Documents',
      feedName: 'Department of State Documents',
      branch: 'Executive',
      topic: 'N/A',
      buttonName: '',
      viewAllLink: '/us/foreignaffairs',
      showOnHomePage: true
    },
    {
      id: 'defenseNews',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=defense&order_by=created_at',
      title: 'Department of Defense News',
      feedName: 'Department of Defense News',
      branch: 'Executive',
      topic: 'Foreign Affairs',
      buttonName: '',
      viewAllLink: '/us/foreignaffairs',
      showOnHomePage: true
    },
    {
      id: 'defenseDocuments',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=defense&order_by=created_at&filter_column=agency&filter_string=Defense%20Department',
      title: 'Department of Defense Documents',
      feedName: 'Department of Defense Documents',
      branch: 'Executive',
      topic: 'Foreign Affairs',
      buttonName: '',
      viewAllLink: '/us/foreignaffairs',
      showOnHomePage: true
    },
    {
      id: 'houseForeignAffairs',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=committee_on_foreign_affairs_meeting_feed&order_by=created_at',
      title: 'House Committee on Foreign Affairs',
      feedName: 'House Committee on Foreign Affairs',
      branch: 'Legislative',
      topic: 'Foreign Affairs',
      buttonName: '',
      viewAllLink: '/us/foreignaffairs',
      showOnHomePage: false
    },
    {
      id: 'houseForeignAffairsMaterials',
      type: 'normal',
      apiEndpoint: '&skip=0&committee=Committee%20on%20Foreign%20Affairs&chamber=HOUSE',
      title: 'House Committee on Foreign Affairs Materials',
      feedName: 'House Committee on Foreign Affairs Materials',
      branch: 'Legislative',
      topic: 'Foreign Affairs',
      buttonName: 'Bill',
      viewAllLink: '/us/foreignaffairs',
      showOnHomePage: false,
      useCommitteeAPI: true 
    },
    {
      id: 'senateForeignRelations',
      type: 'normal',
      apiEndpoint: '&skip=0&committee=Committee%20on%20Foreign%20Relations&chamber=SENATE',
      title: 'Senate Committee on Foreign Relations',
      feedName: 'Senate Committee on Foreign Relations',
      branch: 'Legislative',
      topic: 'Foreign Affairs',
      buttonName: 'Bill',
      viewAllLink: '/us/foreignaffairs',
      showOnHomePage: false,
      useCommitteeAPI: true 
    }
  ],
  health: [
    {
      id: 'healthAndHumanServicesNews',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=health_and_human_services&order_by=created_at',
      title: 'Health and Human Services News',
      feedName: 'Health and Human Services News',
      branch: 'Executive',
      topic: 'Health',
      buttonName: 'Document',
      viewAllLink: '/us/health',
      showOnHomePage: true
    },
    {
      id: 'healthAndHumanServicesDocuments',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=health_and_human_services&order_by=created_at&filter_column=agency&filter_string=Health%20and%20Human%20Services%20Department',
      title: 'Health and Human Services Documents',
      feedName: 'Health and Human Services Documents',
      branch: 'Executive',
      topic: 'N/A',
      buttonName: '',
      viewAllLink: '/us/health',
      showOnHomePage: true
    },
    {
      id: 'agencyForHealthcareResearch',
      type: 'normal',
      apiEndpoint: '&table_name=health_and_human_services&agency=Agency%20for%20Healthcare%20Research%20and%20Quality',
      title: 'Agency for Healthcare Research and Quality Documents',
      feedName: 'Agency for Healthcare Research and Quality Documents',
      branch: 'Executive',
      topic: 'Health',
      buttonName: 'Doc',
      viewAllLink: '/us/health',
      showOnHomePage: true
    },
    {
      id: 'agencyForToxicSubstances',
      type: 'normal',
      apiEndpoint: '&table_name=health_and_human_services&agency=Agency%20for%20Toxic%20Substances%20and%20Disease%20Registry',
      title: 'Agency for Toxic Substances and Disease Registry Documents',
      feedName: 'Agency for Toxic Substances and Disease Registry Documents',
      branch: 'Executive',
      topic: 'Health',
      buttonName: 'Doc',
      viewAllLink: '/us/health',
      showOnHomePage: true
    },
    {
      id: 'agingAdministration',
      type: 'normal',
      apiEndpoint: '&table_name=health_and_human_services&agency=Aging%20Administration',
      title: 'Aging Administration Documents',
      feedName: 'Aging Administration Documents',
      branch: 'Executive',
      topic: 'Health',
      buttonName: 'Doc',
      viewAllLink: '/us/health',
      showOnHomePage: false
    },
    {
      id: 'centersForDiseaseControl',
      type: 'normal',
      apiEndpoint: '&table_name=health_and_human_services&agency=Centers%20for%20Disease%20Control%20and%20Prevention',
      title: 'Centers for Disease Control and Prevention Documents',
      feedName: 'Centers for Disease Control and Prevention Documents',
      branch: 'Executive',
      topic: 'Health',
      buttonName: 'Doc',
      viewAllLink: '/us/health',
      showOnHomePage: false
    },
    {
      id: 'childrenAndFamiliesAdministration',
      type: 'normal',
      apiEndpoint: '&table_name=health_and_human_services&agency=Children%20and%20Families%20Administration',
      title: 'Children and Families Administration Documents',
      feedName: 'Children and Families Administration Documents',
      branch: 'Executive',
      topic: 'Health',
      buttonName: 'Doc',
      viewAllLink: '/us/health',
      showOnHomePage: false
    },
    {
      id: 'communityLivingAdministration',
      type: 'normal',
      apiEndpoint: '&table_name=health_and_human_services&agency=Community%20Living%20Administration',
      title: 'Community Living Administration Documents',
      feedName: 'Community Living Administration Documents',
      branch: 'Executive',
      topic: 'Health',
      buttonName: 'Doc',
      viewAllLink: '/us/health',
      showOnHomePage: false
    },
    {
      id: 'foodAndDrugAdministration',
      type: 'normal',
      apiEndpoint: '&table_name=health_and_human_services&agency=Food%20and%20Drug%20Administration',
      title: 'Food and Drug Administration Documents',
      feedName: 'Food and Drug Administration Documents',
      branch: 'Executive',
      topic: 'Health',
      buttonName: 'Doc',
      viewAllLink: '/us/health',
      showOnHomePage: false
    },
    {
      id: 'healthCareFinanceAdministration',
      type: 'normal',
      apiEndpoint: '&table_name=health_and_human_services&agency=Health%20Care%20Finance%20Administration',
      title: 'Health Care Finance Administration Documents',
      feedName: 'Health Care Finance Administration Documents',
      branch: 'Executive',
      topic: 'Health',
      buttonName: 'Doc',
      viewAllLink: '/us/health',
      showOnHomePage: false
    },
    {
      id: 'healthResourcesAndServicesAdministration',
      type: 'normal',
      apiEndpoint: '&table_name=health_and_human_services&agency=Health%20Resources%20and%20Services%20Administration',
      title: 'Health Resources and Services Administration Documents',
      feedName: 'Health Resources and Services Administration Documents',
      branch: 'Executive',
      topic: 'Health',
      buttonName: 'Doc',
      viewAllLink: '/us/health',
      showOnHomePage: false
    },
    {
      id: 'indianHealthService',
      type: 'normal',
      apiEndpoint: '&table_name=health_and_human_services&agency=Indian%20Health%20Service',
      title: 'Indian Health Service Documents',
      feedName: 'Indian Health Service Documents',
      branch: 'Executive',
      topic: 'Health',
      buttonName: 'Doc',
      viewAllLink: '/us/health',
      showOnHomePage: false
    },
    {
      id: 'nationalInstitutesOfHealth',
      type: 'normal',
      apiEndpoint: '&table_name=health_and_human_services&agency=National%20Institutes%20of%20Health',
      title: 'National Institutes of Health Documents',
      feedName: 'National Institutes of Health Documents',
      branch: 'Executive',
      topic: 'Health',
      buttonName: 'Doc',
      viewAllLink: '/us/health',
      showOnHomePage: false
    },
    {
      id: 'nationalLibraryOfMedicine',
      type: 'normal',
      apiEndpoint: '&table_name=health_and_human_services&agency=National%20Library%20of%20Medicine',
      title: 'National Library of Medicine Documents',
      feedName: 'National Library of Medicine Documents',
      branch: 'Executive',
      topic: 'Health',
      buttonName: 'Doc',
      viewAllLink: '/us/health',
      showOnHomePage: false
    },
    {
      id: 'programSupportCenter',
      type: 'normal',
      apiEndpoint: '&table_name=health_and_human_services&agency=Program%20Support%20Center',
      title: 'Program Support Center Documents',
      feedName: 'Program Support Center Documents',
      branch: 'Executive',
      topic: 'Health',
      buttonName: 'Doc',
      viewAllLink: '/us/health',
      showOnHomePage: false
    }
  ],
  infrastructure: [
    {
      id: 'housingAndUrbanDevelopmentNews',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=housing_and_urban_development&order_by=created_at',
      title: 'HUD News',
      feedName: 'HUD News',
      branch: 'Executive',
      topic: 'Infrastructure',
      buttonName: 'Document',
      viewAllLink: '/us/infrastructure',
      showOnHomePage: true
    },
    {
      id: 'housingAndUrbanDevelopmentDocuments',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=housing_and_urban_development&order_by=created_at&filter_column=collection_name&filter_string=Department%20of%20Housing%20And%20Urban%20Development%20Documents',
      title: 'HUD Documents',
      feedName: 'HUD Documents',
      branch: 'Executive',
      topic: 'Infrastructure',
      buttonName: 'Document',
      viewAllLink: '/us/infrastructure',
      showOnHomePage: true
    },
    {
      id: 'transportationDocuments',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=transportation&order_by=created_at&filter_column=agency&filter_string=Transportation%20Department',
      title: 'Department of Transportation Documents',
      feedName: 'Department of Transportation Documents',
      branch: 'Executive',
      topic: 'N/A',
      buttonName: 'Document',
      viewAllLink: '/us/infrastructure',
      showOnHomePage: true
    },
    {
      id: 'energyDocuments',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=energy&order_by=created_at&filter_column=agency&filter_string=Energy%20Department',
      title: 'Department of Energy Documents',
      feedName: 'Department of Energy Documents',
      branch: 'Executive',
      topic: 'Foreign Affairs',
      buttonName: 'Document',
      viewAllLink: '/us/infrastructure',
      showOnHomePage: true
    },
    {
      id: 'energyEfficiencyRenewable',
      type: 'normal',
      apiEndpoint: '&table_name=energy&agency=Energy%20Efficiency%20and%20Renewable%20Energy%20Office',
      title: 'Energy Efficiency and Renewable Energy Office',
      feedName: 'Energy Efficiency and Renewable Energy Office',
      branch: 'Executive',
      topic: 'Energy',
      buttonName: 'Doc',
      viewAllLink: '/us/infrastructure',
      showOnHomePage: false
    },
    {
      id: 'energyInformation',
      type: 'normal',
      apiEndpoint: '&table_name=energy&agency=Energy%20Information%20Administration',
      title: 'Energy Information Administration',
      feedName: 'Energy Information Administration',
      branch: 'Executive',
      topic: 'Energy',
      buttonName: 'Doc',
      viewAllLink: '/us/infrastructure',
      showOnHomePage: false
    },
    {
      id: 'energyResearch',
      type: 'normal',
      apiEndpoint: '&table_name=energy&agency=Energy%20Research%20Office',
      title: 'Energy Research Office',
      feedName: 'Energy Research Office',
      branch: 'Executive',
      topic: 'Energy',
      buttonName: 'Doc',
      viewAllLink: '/us/infrastructure',
      showOnHomePage: false
    },
    {
      id: 'environmentEnergy',
      type: 'normal',
      apiEndpoint: '&table_name=energy&agency=Environment%20Office%2C%20Energy%20Department',
      title: 'Environment Office, Energy Department',
      feedName: 'Environment Office, Energy Department',
      branch: 'Executive',
      topic: 'Energy',
      buttonName: 'Doc',
      viewAllLink: '/us/infrastructure',
      showOnHomePage: false
    },
    {
      id: 'ferc',
      type: 'normal',
      apiEndpoint: '&table_name=energy&agency=Federal%20Energy%20Regulatory%20Commission',
      title: 'Federal Energy Regulatory Commission',
      feedName: 'Federal Energy Regulatory Commission',
      branch: 'Executive',
      topic: 'Energy',
      buttonName: 'Doc',
      viewAllLink: '/us/infrastructure',
      showOnHomePage: false
    },
    {
      id: 'nnsa',
      type: 'normal',
      apiEndpoint: '&table_name=energy&agency=National%20Nuclear%20Security%20Administration',
      title: 'National Nuclear Security Administration',
      feedName: 'National Nuclear Security Administration',
      branch: 'Executive',
      topic: 'Energy',
      buttonName: 'Doc',
      viewAllLink: '/us/infrastructure',
      showOnHomePage: false
    },
    {
      id: 'commercialSpace',
      type: 'normal',
      apiEndpoint: '&table_name=transportation&agency=Commercial%20Space%20Transportation%20Office',
      title: 'Commercial Space Transportation Office',
      feedName: 'Commercial Space Transportation Office',
      branch: 'Executive',
      topic: 'Infrastructure',
      buttonName: 'Doc',
      viewAllLink: '/us/infrastructure',
      showOnHomePage: false
    },
    {
      id: 'faa',
      type: 'normal',
      apiEndpoint: '&table_name=transportation&agency=Federal%20Aviation%20Administration',
      title: 'Federal Aviation Administration',
      feedName: 'Federal Aviation Administration',
      branch: 'Executive',
      topic: 'Infrastructure',
      buttonName: 'Doc',
      viewAllLink: '/us/infrastructure',
      showOnHomePage: false
    },
    {
      id: 'federalHighway',
      type: 'normal',
      apiEndpoint: '&table_name=transportation&agency=Federal%20Highway%20Administration',
      title: 'Federal Highway Administration',
      feedName: 'Federal Highway Administration',
      branch: 'Executive',
      topic: 'Infrastructure',
      buttonName: 'Doc',
      viewAllLink: '/us/infrastructure',
      showOnHomePage: false
    },
    {
      id: 'fmcsa',
      type: 'normal',
      apiEndpoint: '&table_name=transportation&agency=Federal%20Motor%20Carrier%20Safety%20Administration',
      title: 'Federal Motor Carrier Safety Administration',
      feedName: 'Federal Motor Carrier Safety Administration',
      branch: 'Executive',
      topic: 'Infrastructure',
      buttonName: 'Doc',
      viewAllLink: '/us/infrastructure',
      showOnHomePage: false
    },
    {
      id: 'federalRailroad',
      type: 'normal',
      apiEndpoint: '&table_name=transportation&agency=Federal%20Railroad%20Administration',
      title: 'Federal Railroad Administration',
      feedName: 'Federal Railroad Administration',
      branch: 'Executive',
      topic: 'Infrastructure',
      buttonName: 'Doc',
      viewAllLink: '/us/infrastructure',
      showOnHomePage: false
    },
    {
      id: 'fta',
      type: 'normal',
      apiEndpoint: '&table_name=transportation&agency=Federal%20Transit%20Administration',
      title: 'Federal Transit Administration',
      feedName: 'Federal Transit Administration',
      branch: 'Executive',
      topic: 'Infrastructure',
      buttonName: 'Doc',
      viewAllLink: '/us/infrastructure',
      showOnHomePage: false
    },
    {
      id: 'greatLakesSeaway',
      type: 'normal',
      apiEndpoint: '&table_name=transportation&agency=Great%20Lakes%20St.%20Lawrence%20Seaway%20Development%20Corporation',
      title: 'Great Lakes St. Lawrence Seaway Development Corporation',
      feedName: 'Great Lakes St. Lawrence Seaway Development Corporation',
      branch: 'Executive',
      topic: 'Infrastructure',
      buttonName: 'Doc',
      viewAllLink: '/us/infrastructure',
      showOnHomePage: false
    },
    {
      id: 'maritime',
      type: 'normal',
      apiEndpoint: '&table_name=transportation&agency=Maritime%20Administration',
      title: 'Maritime Administration',
      feedName: 'Maritime Administration',
      branch: 'Executive',
      topic: 'Infrastructure',
      buttonName: 'Doc',
      viewAllLink: '/us/infrastructure',
      showOnHomePage: false
    },
    {
      id: 'nhtsa',
      type: 'normal',
      apiEndpoint: '&table_name=transportation&agency=National%20Highway%20Traffic%20Safety%20Administration',
      title: 'National Highway Traffic Safety Administration',
      feedName: 'National Highway Traffic Safety Administration',
      branch: 'Executive',
      topic: 'Infrastructure',
      buttonName: 'Doc',
      viewAllLink: '/us/infrastructure',
      showOnHomePage: false
    },
    {
      id: 'omcs',
      type: 'normal',
      apiEndpoint: '&table_name=transportation&agency=Office%20of%20Motor%20Carrier%20Safety',
      title: 'Office of Motor Carrier Safety',
      feedName: 'Office of Motor Carrier Safety',
      branch: 'Executive',
      topic: 'Infrastructure',
      buttonName: 'Doc',
      viewAllLink: '/us/infrastructure',
      showOnHomePage: false
    },
    {
      id: 'phmsa',
      type: 'normal',
      apiEndpoint: '&table_name=transportation&agency=Pipeline%20and%20Hazardous%20Materials%20Safety%20Administration',
      title: 'Pipeline and Hazardous Materials Safety Administration',
      feedName: 'Pipeline and Hazardous Materials Safety Administration',
      branch: 'Executive',
      topic: 'Infrastructure',
      buttonName: 'Doc',
      viewAllLink: '/us/infrastructure',
      showOnHomePage: false
    },
    {
      id: 'rita',
      type: 'normal',
      apiEndpoint: '&table_name=transportation&agency=Research%20and%20Innovative%20Technology%20Administration',
      title: 'Research and Innovative Technology Administration',
      feedName: 'Research and Innovative Technology Administration',
      branch: 'Executive',
      topic: 'Infrastructure',
      buttonName: 'Doc',
      viewAllLink: '/us/infrastructure',
      showOnHomePage: false
    },
    {
      id: 'rspa',
      type: 'normal',
      apiEndpoint: '&table_name=transportation&agency=Research%20and%20Special%20Programs%20Administration',
      title: 'Research and Special Programs Administration',
      feedName: 'Research and Special Programs Administration',
      branch: 'Executive',
      topic: 'Infrastructure',
      buttonName: 'Doc',
      viewAllLink: '/us/infrastructure',
      showOnHomePage: false
    },
    {
      id: 'tsb',
      type: 'normal',
      apiEndpoint: '&table_name=transportation&agency=Transportation%20Statistics%20Bureau',
      title: 'Transportation Statistics Bureau',
      feedName: 'Transportation Statistics Bureau',
      branch: 'Executive',
      topic: 'Infrastructure',
      buttonName: 'Doc',
      viewAllLink: '/us/infrastructure',
      showOnHomePage: false
    },
    {
      id: 'spa',
      type: 'normal',
      apiEndpoint: '&table_name=energy&agency=Southeastern%20Power%20Administration',
      title: 'Southeastern Power Administration',
      feedName: 'Southeastern Power Administration',
      branch: 'Executive',
      topic: 'Energy',
      buttonName: 'Doc',
      viewAllLink: '/us/infrastructure',
      showOnHomePage: false
    },
    {
      id: 'swpa',
      type: 'normal',
      apiEndpoint: '&table_name=energy&agency=Southwestern%20Power%20Administration',
      title: 'Southwestern Power Administration',
      feedName: 'Southwestern Power Administration',
      branch: 'Executive',
      topic: 'Energy',
      buttonName: 'Doc',
      viewAllLink: '/us/infrastructure',
      showOnHomePage: false
    },
    {
      id: 'wapa',
      type: 'normal',
      apiEndpoint: '&table_name=energy&agency=Western%20Area%20Power%20Administration',
      title: 'Western Area Power Administration',
      feedName: 'Western Area Power Administration',
      branch: 'Executive',
      topic: 'Energy',
      buttonName: 'Doc',
      viewAllLink: '/us/infrastructure',
      showOnHomePage: false
    },
    {
      id: 'apa',
      type: 'normal',
      apiEndpoint: '&table_name=energy&agency=Alaska%20Power%20Administration',
      title: 'Alaska Power Administration',
      feedName: 'Alaska Power Administration',
      branch: 'Executive',
      topic: 'Energy',
      buttonName: 'Doc',
      viewAllLink: '/us/infrastructure',
      showOnHomePage: false
    },
    {
      id: 'bpa',
      type: 'normal',
      apiEndpoint: '&table_name=energy&agency=Bonneville%20Power%20Administration',
      title: 'Bonneville Power Administration',
      feedName: 'Bonneville Power Administration',
      branch: 'Executive',
      topic: 'Energy',
      buttonName: 'Doc',
      viewAllLink: '/us/infrastructure',
      showOnHomePage: false
    }
  ],
  justice: [
    {
      id: 'justiceNews',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=justice&order_by=created_at',
      title: 'Department of Justice News',
      feedName: 'Department of Justice News',
      branch: 'Executive',
      topic: 'N/A',
      buttonName: 'Document',
      viewAllLink: '/us/justice',
      showOnHomePage: true
    },
    {
      id: 'justiceDocs',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=justice&order_by=created_at&filter_column=agency&filter_string=Justice%20Department',
      title: 'Department of Justice Documents',
      feedName: 'Department of Justice Documents',
      branch: 'Executive',
      topic: 'N/A',
      buttonName: 'Document',
      viewAllLink: '/us/justice',
      showOnHomePage: true
    },
    {
      id: 'antitrustDocs',
      type: 'normal',
      apiEndpoint: '&table_name=justice&agency=Antitrust%20Division',
      title: 'Antitrust Division',
      feedName: 'Antitrust Division',
      branch: 'Executive',
      topic: 'Justice',
      buttonName: 'Doc',
      viewAllLink: '/us/justice',
      showOnHomePage: true
    },
    {
      id: 'deaDocs',
      type: 'normal',
      apiEndpoint: '&table_name=justice&agency=Drug%20Enforcement%20Administration',
      title: 'Drug Enforcement Administration',
      feedName: 'Drug Enforcement Administration',
      branch: 'Executive',
      topic: 'Justice',
      buttonName: 'Doc',
      viewAllLink: '/us/justice',
      showOnHomePage: true
    },
    {
      id: 'fbiDocs',
      type: 'normal',
      apiEndpoint: '&table_name=justice&agency=Federal%20Bureau%20of%20Investigation',
      title: 'Federal Bureau of Investigation',
      feedName: 'Federal Bureau of Investigation',
      branch: 'Executive',
      topic: 'Justice',
      buttonName: 'Doc',
      viewAllLink: '/us/justice',
      showOnHomePage: false
    },
    {
      id: 'fpiDocs',
      type: 'normal',
      apiEndpoint: '&table_name=justice&agency=Federal%20Prison%20Industries',
      title: 'Federal Prison Industries',
      feedName: 'Federal Prison Industries',
      branch: 'Executive',
      topic: 'Justice',
      buttonName: 'Doc',
      viewAllLink: '/us/justice',
      showOnHomePage: false
    },
    {
      id: 'fcscDocs',
      type: 'normal',
      apiEndpoint: '&table_name=justice&agency=Foreign%20Claims%20Settlement%20Commission',
      title: 'Foreign Claims Settlement Commission',
      feedName: 'Foreign Claims Settlement Commission',
      branch: 'Executive',
      topic: 'Justice',
      buttonName: 'Doc',
      viewAllLink: '/us/justice',
      showOnHomePage: false
    },
    {
      id: 'jpoDocs',
      type: 'normal',
      apiEndpoint: '&table_name=justice&agency=Justice%20Programs%20Office',
      title: 'Justice Programs Office',
      feedName: 'Justice Programs Office',
      branch: 'Executive',
      topic: 'Justice',
      buttonName: 'Doc',
      viewAllLink: '/us/justice',
      showOnHomePage: false
    },
    {
      id: 'jjdpoDocs',
      type: 'normal',
      apiEndpoint: '&table_name=justice&agency=Juvenile%20Justice%20and%20Delinquency%20Prevention%20Office',
      title: 'Juvenile Justice and Delinquency Prevention Office',
      feedName: 'Juvenile Justice and Delinquency Prevention Office',
      branch: 'Executive',
      topic: 'Justice',
      buttonName: 'Doc',
      viewAllLink: '/us/justice',
      showOnHomePage: false
    },
    {
      id: 'nicDocs',
      type: 'normal',
      apiEndpoint: '&table_name=justice&agency=National%20Institute%20of%20Corrections',
      title: 'National Institute of Corrections',
      feedName: 'National Institute of Corrections',
      branch: 'Executive',
      topic: 'Justice',
      buttonName: 'Doc',
      viewAllLink: '/us/justice',
      showOnHomePage: false
    },
    {
      id: 'nijDocs',
      type: 'normal',
      apiEndpoint: '&table_name=justice&agency=National%20Institute%20of%20Justice',
      title: 'National Institute of Justice',
      feedName: 'National Institute of Justice',
      branch: 'Executive',
      topic: 'Justice',
      buttonName: 'Doc',
      viewAllLink: '/us/justice',
      showOnHomePage: false
    },
    {
      id: 'pcDocs',
      type: 'normal',
      apiEndpoint: '&table_name=justice&agency=Parole%20Commission',
      title: 'Parole Commission',
      feedName: 'Parole Commission',
      branch: 'Executive',
      topic: 'Justice',
      buttonName: 'Doc',
      viewAllLink: '/us/justice',
      showOnHomePage: false
    },
    {
      id: 'usmsDocs',
      type: 'normal',
      apiEndpoint: '&table_name=justice&agency=United%20States%20Marshals%20Service',
      title: 'United States Marshals Service',
      feedName: 'United States Marshals Service',
      branch: 'Executive',
      topic: 'Justice',
      buttonName: 'Doc',
      viewAllLink: '/us/justice',
      showOnHomePage: false
    },
    {
      id: 'senateJudiciaryMaterials',
      type: 'normal',
      apiEndpoint: '&skip=0&committee=Committee%20on%20the%20Judiciary&chamber=SENATE',
      title: 'Senate Committee on the Judiciary Materials',
      feedName: 'Senate Committee on the Judiciary Materials',
      branch: 'Legislative',
      topic: 'N/A',
      buttonName: 'Bill',
      viewAllLink: '/us/justice',
      showOnHomePage: false,
      useCommitteeAPI: true 
    },
    {
      id: 'houseJudiciaryMaterials',
      type: 'normal',
      apiEndpoint: '&skip=0&committee=Committee%20on%20the%20Judiciary&chamber=HOUSE',
      title: 'House Committee on the Judiciary Materials',
      feedName: 'House Committee on the Judiciary Materials',
      branch: 'Legislative',
      topic: 'N/A',
      buttonName: 'Bill',
      viewAllLink: '/us/justice',
      showOnHomePage: false,
      useCommitteeAPI: true 
    }
  ],
  science: [
    {
      id: 'nsf',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=national_science_foundation&order_by=created_at',
      title: 'National Science Foundation',
      feedName: 'National Science Foundation',
      branch: 'Executive',
      topic: 'Science & Tech',
      buttonName: 'Document',
      viewAllLink: '/us/science',
      showOnHomePage: true
    },
    {
      id: 'nasa',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=nasa&order_by=created_at',
      title: 'NASA',
      feedName: 'NASA',
      branch: 'Executive',
      topic: 'Science & Tech',
      buttonName: 'Document',
      viewAllLink: '/us/science',
      showOnHomePage: true
    },
    {
      id: 'nasaJPL',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=nasa_jpl&order_by=created_at',
      title: 'NASA JPL News',
      feedName: 'NASA JPL News',
      branch: 'Executive',
      topic: 'Science & Tech',
      buttonName: 'Document',
      viewAllLink: '/us/science',
      showOnHomePage: true
    },
    {
      id: 'nist',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=nist&order_by=created_at',
      title: 'NIST News',
      feedName: 'NIST News',
      branch: 'N/A',
      topic: 'Science and Technology',
      buttonName: 'Document',
      viewAllLink: '/us/science',
      showOnHomePage: true
    },
    {
      id: 'energyDepartment',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=energy&order_by=created_at&filter_column=agency&filter_string=Energy%20Department',
      title: 'Department of Energy Documents',
      feedName: 'Department of Energy Documents',
      branch: 'Executive',
      topic: 'N/A',
      buttonName: 'Document',
      viewAllLink: '/us/science',
      showOnHomePage: false
    },
    {
      id: 'houseScienceMaterials',
      type: 'normal',
      apiEndpoint: '&skip=0&committee=Committee%20on%20Science,%20Space,%20and%20Technology&chamber=HOUSE',
      title: 'House Committee on Science, Space, and Technology Materials',
      feedName: 'House Committee on Science, Space, and Technology Materials',
      branch: 'Legislative',
      topic: 'Science & Tech',
      buttonName: 'Bill',
      viewAllLink: '/us/science',
      showOnHomePage: false,
      useCommitteeAPI: true 
    },
    {
      id: 'senateScienceMaterials',
      type: 'normal',
      apiEndpoint: '&skip=0&committee=Committee%20on%20Commerce,%20Science,%20and%20Transportation&chamber=SENATE',
      title: 'Senate Committee on Commerce, Science, and Transportation Materials',
      feedName: 'Senate Committee on Commerce, Science, and Transportation Materials',
      branch: 'Legislative',
      topic: 'Science & Tech',
      buttonName: 'Bill',
      viewAllLink: '/us/science',
      showOnHomePage: false,
      useCommitteeAPI: true 
    }
  ],
  regulations: [
    {
      id: 'rules',
      title: 'Rules',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=regulations&order_by=created_at&filter_column=document_type&filter_string=Rule',
      feedName: 'Rules',
      branch: 'N/A',
      topic: 'Regulations',
      buttonName: 'Document',
      viewAllLink: '/feed/united_states_of_america/regulations',
    },
    {
      id: 'proposedRules',
      title: 'Proposed Rules',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=regulations&order_by=created_at&filter_column=document_type&filter_string=Proposed%20Rule',
      feedName: 'Proposed Rules',
      branch: 'N/A',
      topic: 'Regulations',
      buttonName: 'Document',
      viewAllLink: '/feed/united_states_of_america/regulations',
    },
    {
      id: 'supportingMaterials',
      title: 'Supporting & Related Materials',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=regulations&order_by=created_at&filter_column=document_type&filter_string=Supporting%20%26%20Related%20Material',
      feedName: 'Supporting Materials',
      branch: 'N/A',
      topic: 'Regulations',
      buttonName: 'Document',
      viewAllLink: '/feed/united_states_of_america/regulations',
    },
    {
      id: 'notices',
      title: 'Notices',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=regulations&order_by=created_at&filter_column=document_type&filter_string=Notice',
      feedName: 'Notices',
      branch: 'N/A',
      topic: 'Regulations',
      buttonName: 'Document',
      viewAllLink: '/feed/united_states_of_america/regulations',
    },
    {
      id: 'otherRegulations',
      title: 'Other Regulations',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=regulations&order_by=created_at&filter_column=document_type&filter_string=Other',
      feedName: 'Other Regulations',
      branch: 'N/A',
      topic: 'Regulations',
      buttonName: 'Document',
      viewAllLink: '/feed/united_states_of_america/regulations',
    },
  ],


  house: {
    departmentInfo: {
      name: 'House of Representatives',
      shortName: 'House',
      description: 'The House of Representatives is the lower chamber of the United States Congress, with members serving two-year terms representing districts of approximately equal population.',
      image: '/house-logo.png',
      officialURL: 'https://www.house.gov'
    },
    
    committees: [
      {
        id: 'agriculture',
        name: 'Committee on Agriculture',
        shortName: 'Agriculture',
        description: 'Jurisdiction over agriculture, rural development, food safety, and nutrition programs.',
        image: '/committee-logos/agriculture.png',
        officialURL: 'https://agriculture.house.gov',
        meetingFeed: {
          apiEndpoint: '&skip=0&schema=united_states_of_america&table=committee_on_agriculture_meeting_feed&order_by=created_at',
          feedName: 'Agriculture Committee Meetings',
          buttonName: 'Document'
        },
        materialsFeed: {
          apiEndpoint: '&skip=0&committee=Committee%20on%20Agriculture&chamber=HOUSE',
          feedName: 'Agriculture Committee Materials',
          buttonName: 'Bill',
          useCommitteeAPI: true
        }
      },
      
      {
        id: 'armed-services',
        name: 'Committee on Armed Services',
        shortName: 'Armed Services',
        description: 'Oversight of the Department of Defense and military affairs.',
        image: '/committee-logos/armed-services.png',
        officialURL: 'https://armedservices.house.gov',
        meetingFeed: {
          apiEndpoint: '&skip=0&schema=united_states_of_america&table=committee_on_armed_services_meeting_feed&order_by=created_at',
          feedName: 'Armed Services Committee Meetings',
          buttonName: 'Document'
        },
        materialsFeed: {
          apiEndpoint: '&skip=0&committee=Committee%20on%20Armed%20Services&chamber=HOUSE',
          feedName: 'Armed Services Committee Materials',
          buttonName: 'Bill',
          useCommitteeAPI: true
        }
      },
  
      {
        id: 'financial-services',
        name: 'Committee on Financial Services',
        shortName: 'Financial Services',
        description: 'Banking, insurance, and financial markets oversight.',
        image: '/committee-logos/financial-services.png',
        officialURL: 'https://financialservices.house.gov',
        meetingFeed: {
          apiEndpoint: '&skip=0&schema=united_states_of_america&table=committee_on_financial_services_meeting_feed&order_by=created_at',
          feedName: 'Financial Services Committee Meetings',
          buttonName: 'Document'
        },
        materialsFeed: {
          apiEndpoint: '&skip=0&committee=Committee%20on%20Financial%20Services&chamber=HOUSE',
          feedName: 'Financial Services Committee Materials',
          buttonName: 'Bill',
          useCommitteeAPI: true
        }
      },
  
      {
        id: 'judiciary',
        name: 'Committee on the Judiciary',
        shortName: 'Judiciary',
        description: 'Constitutional law, federal courts, immigration, and civil liberties.',
        image: '/committee-logos/judiciary.png',
        officialURL: 'https://judiciary.house.gov',
        meetingFeed: {
          apiEndpoint: '&skip=0&schema=united_states_of_america&table=committee_on_the_judiciary_meeting_feed&order_by=created_at',
          feedName: 'Judiciary Committee Meetings',
          buttonName: 'Document'
        },
        materialsFeed: {
          apiEndpoint: '&skip=0&committee=Committee%20on%20the%20Judiciary&chamber=HOUSE',
          feedName: 'Judiciary Committee Materials',
          buttonName: 'Bill',
          useCommitteeAPI: true
        }
      },
  
      {
        id: 'foreign-affairs',
        name: 'Committee on Foreign Affairs',
        shortName: 'Foreign Affairs',
        description: 'Foreign policy, international relations, and diplomatic affairs.',
        image: '/committee-logos/foreign-affairs.png',
        officialURL: 'https://foreignaffairs.house.gov',
        meetingFeed: {
          apiEndpoint: '&skip=0&schema=united_states_of_america&table=committee_on_foreign_affairs_meeting_feed&order_by=created_at',
          feedName: 'Foreign Affairs Committee Meetings',
          buttonName: 'Document'
        },
        materialsFeed: {
          apiEndpoint: '&skip=0&committee=Committee%20on%20Foreign%20Affairs&chamber=HOUSE',
          feedName: 'Foreign Affairs Committee Materials',
          buttonName: 'Bill',
          useCommitteeAPI: true
        }
      },
      {
        id: 'appropriations',
        name: 'Committee on Appropriations',
        shortName: 'Appropriations',
        description: 'Jurisdiction over federal spending and appropriations bills.',
        image: '/committee-logos/appropriations.png',
        officialURL: 'https://appropriations.house.gov',
        meetingFeed: {
          apiEndpoint: '&skip=0&schema=united_states_of_america&table=committee_on_appropriations_meeting_feed&order_by=created_at',
          feedName: 'Appropriations Committee Meetings',
          buttonName: 'Doc'
        },
        materialsFeed: {
          apiEndpoint: '&skip=0&committee=Committee%20on%20Appropriations&chamber=HOUSE',
          feedName: 'Appropriations Committee Materials',
          buttonName: 'Bill',
          useCommitteeAPI: true
        }
      },
      
      {
        id: 'education-workforce',
        name: 'Committee on Education and the Workforce',
        shortName: 'Education & Workforce',
        description: 'Jurisdiction over education, labor, and workforce programs.',
        image: '/committee-logos/education-workforce.png',
        officialURL: 'https://edworkforce.house.gov',
        meetingFeed: {
          apiEndpoint: '&skip=0&schema=united_states_of_america&table=committee_on_education_and_the_workforce_meeting_feed&order_by=created_at',
          feedName: 'Education and Workforce Committee Meetings',
          buttonName: 'Document'
        },
        materialsFeed: {
          apiEndpoint: '&skip=0&committee=Committee%20on%20Education%20and%20the%20Workforce&chamber=HOUSE',
          feedName: 'Education and Workforce Committee Materials',
          buttonName: 'Bill',
          useCommitteeAPI: true
        }
      },
      
      {
        id: 'energy-commerce',
        name: 'Committee on Energy and Commerce',
        shortName: 'Energy & Commerce',
        description: 'Jurisdiction over energy policy, healthcare, telecommunications, and consumer protection.',
        image: '/committee-logos/energy-commerce.png',
        officialURL: 'https://energycommerce.house.gov',
        meetingFeed: {
          apiEndpoint: '&skip=0&schema=united_states_of_america&table=committee_on_energy_and_commerce_meeting_feed&order_by=created_at',
          feedName: 'Energy and Commerce Committee Meetings',
          buttonName: 'Document'
        },
        materialsFeed: {
          apiEndpoint: '&skip=0&committee=Committee%20on%20Energy%20and%20Commerce&chamber=HOUSE',
          feedName: 'Energy and Commerce Committee Materials',
          buttonName: 'Bill',
          useCommitteeAPI: true
        }
      },
      
      {
        id: 'ethics',
        name: 'Committee on Ethics',
        shortName: 'Ethics',
        description: 'Jurisdiction over standards of official conduct for House members and staff.',
        image: '/committee-logos/ethics.png',
        officialURL: 'https://ethics.house.gov',
        meetingFeed: {
          apiEndpoint: '&skip=0&schema=united_states_of_america&table=committee_on_ethics_meeting_feed&order_by=created_at',
          feedName: 'Ethics Committee Meetings',
          buttonName: 'Document'
        },
        materialsFeed: {
          apiEndpoint: '&skip=0&committee=Committee%20on%20Ethics&chamber=HOUSE',
          feedName: 'Ethics Committee Materials',
          buttonName: 'Bill',
          useCommitteeAPI: true
        }
      },
      
      {
        id: 'homeland-security',
        name: 'Committee on Homeland Security',
        shortName: 'Homeland Security',
        description: 'Jurisdiction over homeland security policy and the Department of Homeland Security.',
        image: '/committee-logos/homeland-security.png',
        officialURL: 'https://homeland.house.gov',
        meetingFeed: {
          apiEndpoint: '&skip=0&schema=united_states_of_america&table=committee_on_homeland_security_meeting_feed&order_by=created_at',
          feedName: 'Homeland Security Committee Meetings',
          buttonName: 'Document'
        },
        materialsFeed: {
          apiEndpoint: '&skip=0&committee=Committee%20on%20Homeland%20Security&chamber=HOUSE',
          feedName: 'Homeland Security Committee Materials',
          buttonName: 'Bill',
          useCommitteeAPI: true
        }
      }
    ]
  },

  senate: {
    departmentInfo: {
      name: 'United States Senate',
      shortName: 'Senate',
      description: 'The Senate is the upper chamber of the United States Congress, with two senators representing each state serving six-year terms.',
      image: '/senate-logo.png',
      officialURL: 'https://www.senate.gov'
    },
    
    committees: [
      {
        id: 'agriculture-nutrition-forestry',
        name: 'Committee on Agriculture, Nutrition, and Forestry',
        shortName: 'Agriculture',
        description: 'Jurisdiction over agriculture, nutrition, forestry, and rural development.',
        image: '/committee-logos/senate-agriculture.png',
        officialURL: 'https://www.agriculture.senate.gov',
        newsFeed: {
          apiEndpoint: '&skip=0&schema=united_states_of_america&table=senate_committee_news&order_by=created_at&filter_column=committee&filter_string=Committee%20on%20Agriculture%2C%20Nutrition%2C%20and%20Forestry',
          feedName: 'Agriculture Committee News',
          buttonName: 'News'
        },
        materialsFeed: {
          apiEndpoint: '&skip=0&committee=Committee%20on%20Agriculture,%20Nutrition,%20and%20Forestry&chamber=SENATE',
          feedName: 'Agriculture Committee Materials',
          buttonName: 'Bill',
          useCommitteeAPI: true
        }
      },
  
      {
        id: 'appropriations',
        name: 'Committee on Appropriations',
        shortName: 'Appropriations',
        description: 'Jurisdiction over federal spending and appropriations legislation.',
        image: '/committee-logos/senate-appropriations.png',
        officialURL: 'https://www.appropriations.senate.gov',
        materialsFeed: {
          apiEndpoint: '&skip=0&committee=Committee%20on%20Appropriations&chamber=SENATE',
          feedName: 'Appropriations Committee Materials',
          buttonName: 'Bill',
          useCommitteeAPI: true
        }
      },
  
      {
        id: 'armed-services',
        name: 'Committee on Armed Services',
        shortName: 'Armed Services',
        description: 'Oversight of the Department of Defense and military affairs.',
        image: '/committee-logos/senate-armed-services.png',
        officialURL: 'https://www.armed-services.senate.gov',
        newsFeed: {
          apiEndpoint: '&skip=0&schema=united_states_of_america&table=senate_committee_news&order_by=created_at&filter_column=committee&filter_string=Committee%20on%20Armed%20Services',
          feedName: 'Armed Services Committee News',
          buttonName: 'News'
        },
        materialsFeed: {
          apiEndpoint: '&skip=0&committee=Committee%20on%20Armed%20Services&chamber=SENATE',
          feedName: 'Armed Services Committee Materials',
          buttonName: 'Bill',
          useCommitteeAPI: true
        }
      },
  
      {
        id: 'banking-housing-urban-affairs',
        name: 'Committee on Banking, Housing, and Urban Affairs',
        shortName: 'Banking',
        description: 'Jurisdiction over banking, financial institutions, housing, and urban development.',
        image: '/committee-logos/senate-banking.png',
        officialURL: 'https://www.banking.senate.gov',
        newsFeed: {
          apiEndpoint: '&skip=0&schema=united_states_of_america&table=senate_committee_news&order_by=created_at&filter_column=committee&filter_string=Committee%20on%20Banking%2C%20Housing%2C%20and%20Urban%20Affairs',
          feedName: 'Banking Committee News',
          buttonName: 'News'
        },
        materialsFeed: {
          apiEndpoint: '&skip=0&committee=Committee%20on%20Banking,%20Housing,%20and%20Urban%20Affairs&chamber=SENATE',
          feedName: 'Banking Committee Materials',
          buttonName: 'Bill',
          useCommitteeAPI: true
        }
      },
  
      {
        id: 'budget',
        name: 'Committee on the Budget',
        shortName: 'Budget',
        description: 'Jurisdiction over federal budget process and budget resolutions.',
        image: '/committee-logos/senate-budget.png',
        officialURL: 'https://www.budget.senate.gov',
        newsFeed: {
          apiEndpoint: '&skip=0&schema=united_states_of_america&table=senate_committee_news&order_by=created_at&filter_column=committee&filter_string=Committee%20on%20the%20Budget',
          feedName: 'Budget Committee News',
          buttonName: 'News'
        },
        materialsFeed: {
          apiEndpoint: '&skip=0&committee=Committee%20on%20the%20Budget&chamber=SENATE',
          feedName: 'Budget Committee Materials',
          buttonName: 'Bill',
          useCommitteeAPI: true
        }
      },
  
      {
        id: 'commerce-science-transportation',
        name: 'Committee on Commerce, Science, and Transportation',
        shortName: 'Commerce',
        description: 'Jurisdiction over commerce, science, transportation, and communications.',
        image: '/committee-logos/senate-commerce.png',
        officialURL: 'https://www.commerce.senate.gov',
        newsFeed: {
          apiEndpoint: '&skip=0&schema=united_states_of_america&table=senate_committee_news&order_by=created_at&filter_column=committee&filter_string=Committee%20on%20Commerce%2C%20Science%2C%20and%20Transportation',
          feedName: 'Commerce Committee News',
          buttonName: 'News'
        },
        materialsFeed: {
          apiEndpoint: '&skip=0&committee=Committee%20on%20Commerce,%20Science,%20and%20Transportation&chamber=SENATE',
          feedName: 'Commerce Committee Materials',
          buttonName: 'Bill',
          useCommitteeAPI: true
        }
      },
  
      {
        id: 'energy-natural-resources',
        name: 'Committee on Energy and Natural Resources',
        shortName: 'Energy',
        description: 'Jurisdiction over energy policy and natural resources.',
        image: '/committee-logos/senate-energy.png',
        officialURL: 'https://www.energy.senate.gov',
        newsFeed: {
          apiEndpoint: '&skip=0&schema=united_states_of_america&table=senate_committee_news&order_by=created_at&filter_column=committee&filter_string=Committee%20on%20Energy%20and%20Natural%20Resources',
          feedName: 'Energy Committee News',
          buttonName: 'News'
        },
        materialsFeed: {
          apiEndpoint: '&skip=0&committee=Committee%20on%20Energy%20and%20Natural%20Resources&chamber=SENATE',
          feedName: 'Energy Committee Materials',
          buttonName: 'Bill',
          useCommitteeAPI: true
        }
      },
  
      {
        id: 'environment-public-works',
        name: 'Committee on Environment and Public Works',
        shortName: 'Environment',
        description: 'Jurisdiction over environmental policy and public works.',
        image: '/committee-logos/senate-environment.png',
        officialURL: 'https://www.epw.senate.gov',
        newsFeed: {
          apiEndpoint: '&skip=0&schema=united_states_of_america&table=senate_committee_news&order_by=created_at&filter_column=committee&filter_string=Committee%20on%20Environment%20and%20Public%20Works',
          feedName: 'Environment Committee News',
          buttonName: 'News'
        },
        materialsFeed: {
          apiEndpoint: '&skip=0&committee=Committee%20on%20Environment%20and%20Public%20Works&chamber=SENATE',
          feedName: 'Environment Committee Materials',
          buttonName: 'Bill',
          useCommitteeAPI: true
        }
      },
  
      {
        id: 'finance',
        name: 'Committee on Finance',
        shortName: 'Finance',
        description: 'Jurisdiction over taxation, trade, and entitlement programs.',
        image: '/committee-logos/senate-finance.png',
        officialURL: 'https://www.finance.senate.gov',
        newsFeed: {
          apiEndpoint: '&skip=0&schema=united_states_of_america&table=senate_committee_news&order_by=created_at&filter_column=committee&filter_string=Committee%20on%20Finance',
          feedName: 'Finance Committee News',
          buttonName: 'News'
        },
        materialsFeed: {
          apiEndpoint: '&skip=0&committee=Committee%20on%20Finance&chamber=SENATE',
          feedName: 'Finance Committee Materials',
          buttonName: 'Bill',
          useCommitteeAPI: true
        }
      },
  
      {
        id: 'foreign-relations',
        name: 'Committee on Foreign Relations',
        shortName: 'Foreign Relations',
        description: 'Jurisdiction over foreign policy, treaties, and diplomatic nominations.',
        image: '/committee-logos/senate-foreign-relations.png',
        officialURL: 'https://www.foreign.senate.gov',
        newsFeed: {
          apiEndpoint: '&skip=0&schema=united_states_of_america&table=senate_committee_news&order_by=created_at&filter_column=committee&filter_string=Committee%20on%20Foreign%20Relations',
          feedName: 'Foreign Relations Committee News',
          buttonName: 'News'
        },
        materialsFeed: {
          apiEndpoint: '&skip=0&committee=Committee%20on%20Foreign%20Relations&chamber=SENATE',
          feedName: 'Foreign Relations Committee Materials',
          buttonName: 'Bill',
          useCommitteeAPI: true
        }
      },
  
      {
        id: 'health-education-labor-pensions',
        name: 'Committee on Health, Education, Labor, and Pensions',
        shortName: 'HELP',
        description: 'Jurisdiction over health, education, labor, and pension policy.',
        image: '/committee-logos/senate-help.png',
        officialURL: 'https://www.help.senate.gov',
        newsFeed: {
          apiEndpoint: '&skip=0&schema=united_states_of_america&table=senate_committee_news&order_by=created_at&filter_column=committee&filter_string=Committee%20on%20Health%2C%20Education%2C%20Labor%2C%20and%20Pension',
          feedName: 'HELP Committee News',
          buttonName: 'News'
        },
        materialsFeed: {
          apiEndpoint: '&skip=0&committee=Committee%20on%20Health%2C%20Education%2C%20Labor%2C%20and%20Pensions&chamber=SENATE',
          feedName: 'HELP Committee Materials',
          buttonName: 'Bill',
          useCommitteeAPI: true
        }
      },
  
      {
        id: 'homeland-security-governmental-affairs',
        name: 'Committee on Homeland Security and Governmental Affairs',
        shortName: 'Homeland Security',
        description: 'Jurisdiction over homeland security and government operations.',
        image: '/committee-logos/senate-homeland.png',
        officialURL: 'https://www.hsgac.senate.gov',
        newsFeed: {
          apiEndpoint: '&skip=0&schema=united_states_of_america&table=senate_committee_news&order_by=created_at&filter_column=committee&filter_string=Committee%20on%20Homeland%20Security%20and%20Governmental%20Affairs',
          feedName: 'Homeland Security Committee News',
          buttonName: 'News'
        },
        materialsFeed: {
          apiEndpoint: '&skip=0&committee=Committee%20on%20Homeland%20Security%20and%20Governmental%20Affairs&chamber=SENATE',
          feedName: 'Homeland Security Committee Materials',
          buttonName: 'Bill',
          useCommitteeAPI: true
        }
      },
  
      {
        id: 'judiciary',
        name: 'Committee on the Judiciary',
        shortName: 'Judiciary',
        description: 'Jurisdiction over federal courts, constitutional amendments, and immigration.',
        image: '/committee-logos/senate-judiciary.png',
        officialURL: 'https://www.judiciary.senate.gov',
        newsFeed: {
          apiEndpoint: '&skip=0&schema=united_states_of_america&table=senate_committee_news&order_by=created_at&filter_column=committee&filter_string=Committee%20on%20the%20Judiciary',
          feedName: 'Judiciary Committee News',
          buttonName: 'News'
        },
        materialsFeed: {
          apiEndpoint: '&skip=0&committee=Committee%20on%20the%20Judiciary&chamber=SENATE',
          feedName: 'Judiciary Committee Materials',
          buttonName: 'Bill',
          useCommitteeAPI: true
        }
      },
  
      {
        id: 'rules-administration',
        name: 'Committee on Rules and Administration',
        shortName: 'Rules',
        description: 'Jurisdiction over Senate rules, federal elections, and the Capitol.',
        image: '/committee-logos/senate-rules.png',
        officialURL: 'https://www.rules.senate.gov',
        newsFeed: {
          apiEndpoint: '&skip=0&schema=united_states_of_america&table=senate_committee_news&order_by=created_at&filter_column=committee&filter_string=Committee%20on%20Rules%20and%20Administration',
          feedName: 'Rules Committee News',
          buttonName: 'News'
        },
        materialsFeed: {
          apiEndpoint: '&skip=0&committee=Committee%20on%20Rules%20and%20Administration&chamber=SENATE',
          feedName: 'Rules Committee Materials',
          buttonName: 'Bill',
          useCommitteeAPI: true
        }
      },
  
      {
        id: 'small-business-entrepreneurship',
        name: 'Committee on Small Business and Entrepreneurship',
        shortName: 'Small Business',
        description: 'Jurisdiction over small business and entrepreneurship policy.',
        image: '/committee-logos/senate-small-business.png',
        officialURL: 'https://www.sbc.senate.gov',
        newsFeed: {
          apiEndpoint: '&skip=0&schema=united_states_of_america&table=senate_committee_news&order_by=created_at&filter_column=committee&filter_string=Committee%20on%20Small%20Businesses%20and%20Entrepreneurship',
          feedName: 'Small Business Committee News',
          buttonName: 'News'
        },
        materialsFeed: {
          apiEndpoint: '&skip=0&committee=Committee%20on%20Small%20Business%20and%20Entrepreneurship&chamber=SENATE',
          feedName: 'Small Business Committee Materials',
          buttonName: 'Bill',
          useCommitteeAPI: true
        }
      },
  
      {
        id: 'veterans-affairs',
        name: "Committee on Veterans' Affairs",
        shortName: "Veterans' Affairs",
        description: 'Jurisdiction over veterans benefits and services.',
        image: '/committee-logos/senate-veterans.png',
        officialURL: 'https://www.veterans.senate.gov',
        newsFeed: {
          apiEndpoint: "&skip=0&schema=united_states_of_america&table=senate_committee_news&order_by=created_at&filter_column=committee&filter_string=Committee%20on%20Veterans%27%20Affairs",
          feedName: "Veterans' Affairs Committee News",
          buttonName: 'News'
        },
      }
    ]
  },


  immigration: [
    {
      id: 'iceNews',
      type: 'normal',
      apiEndpoint: '&schema=united_states_of_america&table=homeland_security&order_by=created_at&filter_column=agency&filter_string=U.S.%20Immigration%20and%20Customs%20Enforcement',
      title: 'ICE News',
      feedName: 'ICE News',
      branch: 'Executive',
      topic: 'Immigration',
      buttonName: 'Doc',
      viewAllLink: '/us/immigration',
      showOnHomePage: true
    }
  ],
  spending: [
    {
      id: 'recentAwards',
      type: 'normal',
      apiEndpoint: '&skip=0&schema=united_states_of_america&table=recent_awards&order_by=start_date',
      title: 'Recent Awards',
      feedName: 'Recent Awards',
      branch: 'N/A',
      topic: 'Spending',
      buttonName: 'Document',
      viewAllLink: '/us/spending',
      showOnHomePage: true
    },
    // {
    //   id: 'dogeCancelContract',
    //   type: 'normal',
    //   apiEndpoint: '&skip=0&schema=united_states_of_america&table=doge_savings&order_by=uploaded_on&filter_column=saving_type&filter_string=Contract',
    //   title: 'DOGE Contract Cancellations',
    //   feedName: 'DOGE Contract Cancellations',
    //   branch: 'N/A',
    //   topic: 'Spending',
    //   buttonName: 'Document',
    //   viewAllLink: '/us/spending',
    //   showOnHomePage: true
    // },
    // {
    //   id: 'dogeCancelGrant',
    //   type: 'normal',
    //   apiEndpoint: '&skip=0&schema=united_states_of_america&table=doge_savings&order_by=uploaded_on&filter_column=saving_type&filter_string=Grant',
    //   title: 'DOGE Grant Cancellations',
    //   feedName: 'DOGE Grant Cancellations',
    //   branch: 'N/A',
    //   topic: 'Spending',
    //   buttonName: 'Document',
    //   viewAllLink: '/us/spending',
    //   showOnHomePage: true
    // },
    // {
    //   id: 'dogeCancelGrantRealEstate',
    //   type: 'normal',
    //   apiEndpoint: '&skip=0&schema=united_states_of_america&table=doge_savings&order_by=annual_lease&filter_column=saving_type&filter_string=Real%20Estate',
    //   title: 'DOGE Real Estate Cancellations',
    //   feedName: 'DOGE Real Estate Cancellations',
    //   branch: 'N/A',
    //   topic: 'Spending',
    //   buttonName: 'Document',
    //   viewAllLink: '/us/spending',
    //   showOnHomePage: true
    // }
  ]

  
};

  





// State information lookup table
const stateInfo = {
  alabama: { fullName: 'Alabama', code: 'al', flagImage: '/alabamaFlag.png', courtCode: 'ala', tableName: 'alabama' },
  alaska: { fullName: 'Alaska', code: 'ak', flagImage: '/alaskaFlag.png', courtCode: 'alaska', tableName: 'alaska' },
  arizona: { fullName: 'Arizona', code: 'az', flagImage: '/arizonaFlag.png', courtCode: 'ariz', tableName: 'arizona' },
  arkansas: { fullName: 'Arkansas', code: 'ar', flagImage: '/arkansasFlag.png', courtCode: 'ark', tableName: 'arkansas' },
  california: { fullName: 'California', code: 'ca', flagImage: '/californiaFlag.png', courtCode: 'cal', tableName: 'california' },
  colorado: { fullName: 'Colorado', code: 'co', flagImage: '/coloradoFlag.png', courtCode: 'colo', tableName: 'colorado' },
  connecticut: { fullName: 'Connecticut', code: 'ct', flagImage: '/connecticutFlag.png', courtCode: 'conn', tableName: 'connecticut' },
  delaware: { fullName: 'Delaware', code: 'de', flagImage: '/delawareFlag.png', courtCode: 'del', tableName: 'delaware' },
  florida: { fullName: 'Florida', code: 'fl', flagImage: '/floridaFlag.png', courtCode: 'fla', tableName: 'florida' },
  georgia: { fullName: 'Georgia', code: 'ga', flagImage: '/georgiaFlag.png', courtCode: 'ga', tableName: 'georgia' },
  hawaii: { fullName: 'Hawaii', code: 'hi', flagImage: '/hawaiiFlag.png', courtCode: 'haw', tableName: 'hawaii' },
  idaho: { fullName: 'Idaho', code: 'id', flagImage: '/idahoFlag.png', courtCode: 'idaho', tableName: 'idaho' },
  illinois: { fullName: 'Illinois', code: 'il', flagImage: '/illinoisFlag.png', courtCode: 'ill', tableName: 'illinois' },
  indiana: { fullName: 'Indiana', code: 'in', flagImage: '/indianaFlag.png', courtCode: 'ind', tableName: 'indiana' },
  iowa: { fullName: 'Iowa', code: 'ia', flagImage: '/iowaFlag.png', courtCode: 'iowa', tableName: 'iowa' },
  kansas: { fullName: 'Kansas', code: 'ks', flagImage: '/kansasFlag.png', courtCode: 'kan', tableName: 'kansas' },
  kentucky: { fullName: 'Kentucky', code: 'ky', flagImage: '/kentuckyFlag.png', courtCode: 'ky', tableName: 'kentucky' },
  louisiana: { fullName: 'Louisiana', code: 'la', flagImage: '/louisianaFlag.png', courtCode: 'la', tableName: 'louisiana' },
  maine: { fullName: 'Maine', code: 'me', flagImage: '/maineFlag.png', courtCode: 'me', tableName: 'maine' },
  maryland: { fullName: 'Maryland', code: 'md', flagImage: '/marylandFlag.png', courtCode: 'md', tableName: 'maryland' },
  massachusetts: { fullName: 'Massachusetts', code: 'ma', flagImage: '/massachusettsFlag.png', courtCode: 'mass', tableName: 'massachusetts' },
  michigan: { fullName: 'Michigan', code: 'mi', flagImage: '/michiganFlag.png', courtCode: 'mich', tableName: 'michigan' },
  minnesota: { fullName: 'Minnesota', code: 'mn', flagImage: '/minnesotaFlag.png', courtCode: 'minn', tableName: 'minnesota' },
  mississippi: { fullName: 'Mississippi', code: 'ms', flagImage: '/mississippiFlag.png', courtCode: 'miss', tableName: 'mississippi' },
  missouri: { fullName: 'Missouri', code: 'mo', flagImage: '/missouriFlag.png', courtCode: 'mo', tableName: 'missouri' },
  montana: { fullName: 'Montana', code: 'mt', flagImage: '/montanaFlag.png', courtCode: 'mont', tableName: 'montana' },
  nebraska: { fullName: 'Nebraska', code: 'ne', flagImage: '/nebraskaFlag.png', courtCode: 'neb', tableName: 'nebraska' },
  nevada: { fullName: 'Nevada', code: 'nv', flagImage: '/nevadaFlag.png', courtCode: 'nev', tableName: 'nevada' },
  newhampshire: { fullName: 'New Hampshire', code: 'nh', flagImage: '/newHampshireFlag.png', courtCode: 'nh', tableName: 'new_hampshire' },
  newjersey: { fullName: 'New Jersey', code: 'nj', flagImage: '/newJerseyFlag.png', courtCode: 'nj', tableName: 'new_jersey' },
  newmexico: { fullName: 'New Mexico', code: 'nm', flagImage: '/newMexicoFlag.png', courtCode: 'nm', tableName: 'new_mexico' },
  newyork: { fullName: 'New York', code: 'ny', flagImage: '/newYorkFlag.png', courtCode: 'ny', tableName: 'new_york' },
  northcarolina: { fullName: 'North Carolina', code: 'nc', flagImage: '/northCarolinaFlag.png', courtCode: 'nc', tableName: 'north_carolina' },
  northdakota: { fullName: 'North Dakota', code: 'nd', flagImage: '/northDakotaFlag.png', courtCode: 'nd', tableName: 'north_dakota' },
  ohio: { fullName: 'Ohio', code: 'oh', flagImage: '/ohioFlag.png', courtCode: 'ohio', tableName: 'ohio' },
  oklahoma: { fullName: 'Oklahoma', code: 'ok', flagImage: '/oklahomaFlag.png', courtCode: 'okla', tableName: 'oklahoma' },
  oregon: { fullName: 'Oregon', code: 'or', flagImage: '/oregonFlag.png', courtCode: 'or', tableName: 'oregon' },
  pennsylvania: { fullName: 'Pennsylvania', code: 'pa', flagImage: '/pennsylvaniaFlag.png', courtCode: 'pa', tableName: 'pennsylvania' },
  rhodeisland: { fullName: 'Rhode Island', code: 'ri', flagImage: '/rhodeIslandFlag.png', courtCode: 'ri', tableName: 'rhode_island' },
  southcarolina: { fullName: 'South Carolina', code: 'sc', flagImage: '/southCarolinaFlag.png', courtCode: 'sc', tableName: 'south_carolina' },
  southdakota: { fullName: 'South Dakota', code: 'sd', flagImage: '/southDakotaFlag.png', courtCode: 'sd', tableName: 'south_dakota' },
  tennessee: { fullName: 'Tennessee', code: 'tn', flagImage: '/tennesseeFlag.png', courtCode: 'tenn', tableName: 'tennessee' },
  texas: { fullName: 'Texas', code: 'tx', flagImage: '/texasFlag.png', courtCode: 'tex', tableName: 'texas' },
  utah: { fullName: 'Utah', code: 'ut', flagImage: '/utahFlag.png', courtCode: 'utah', tableName: 'utah' },
  vermont: { fullName: 'Vermont', code: 'vt', flagImage: '/vermontFlag.png', courtCode: 'vt', tableName: 'vermont' },
  virginia: { fullName: 'Virginia', code: 'va', flagImage: '/virginiaFlag.png', courtCode: 'va', tableName: 'virginia' },
  washington: { fullName: 'Washington', code: 'wa', flagImage: '/washingtonFlag.png', courtCode: 'wash', tableName: 'washington' },
  westvirginia: { fullName: 'West Virginia', code: 'wv', flagImage: '/westVirginiaFlag.png', courtCode: 'wva', tableName: 'west_virginia' },
  wisconsin: { fullName: 'Wisconsin', code: 'wi', flagImage: '/wisconsinFlag.png', courtCode: 'wis', tableName: 'wisconsin' },
  wyoming: { fullName: 'Wyoming', code: 'wy', flagImage: '/wyomingFlag.png', courtCode: 'wyo', tableName: 'wyoming' }
};

// List of states that use the special bills API
const specialBillsApiStates = [
  'wyoming', 'arkansas', 'minnesota', 'mississippi', 'vermont', 'texas'
];

// Factory function to create state feeds (compatible with MobileFeedCarousel)
// Factory function to create state feeds (compatible with MobileFeedCarousel)
export const createStateFeeds = (stateKey) => {
  const stateData = stateInfo[stateKey];
  if (!stateData) return null;

  const { fullName, code, tableName, courtCode } = stateData;
  const usesSpecialBillsApi = specialBillsApiStates.includes(stateKey);

  return {
    legislative: [
      {
        id: `${code}Bills`,
        name: 'Bill Updates',
        displayType: 'normal',
        apiParams: usesSpecialBillsApi
          ? `skip=0&schema=united_states_of_america&table=state_bills&order_by=last_modified&filter_column=state_name&filter_string=${encodeURIComponent(fullName)}`
          : `skip=0&schema=united_states_of_america&table=${code}_bills&order_by=created_at`,
        feedBranch: 'Legislative',
        feedTopic: 'N/A',
        buttonName: 'Bill'
      }
    ],
    executive: [
      {
        id: `${code}Governor`,
        name: 'Governor',
        displayType: 'normal',
        apiParams: `skip=0&schema=united_states_of_america&table=${tableName}&order_by=created_at`,
        feedBranch: 'Executive',
        feedTopic: 'N/A',
        buttonName: 'Document'
      }
    ],
    judicial: [
      {
        id: `${code}Courts`,
        name: 'Supreme Court',
        displayType: 'normal',
        apiParams: `skip=0&schema=united_states_of_america&table=supreme_${courtCode}&order_by=created_at`,
        feedBranch: 'Judicial',
        feedTopic: 'N/A',
        buttonName: 'Doc'
      }
    ],
    // Recently published or changed pages on the state's official websites.
    // Backed by crawl.govglance.org rather than the main API — useFeedData
    // routes on the `crawl` param, so nothing else has to know. No table to
    // check for, so every state gets this one. Drop level=state to widen it
    // to counties and towns.
    updates: [
      {
        id: `${code}Updates`,
        name: 'Web Crawl Updates',
        displayType: 'normal',
        apiParams: `skip=0&crawl=recent&country=us&state=${code}&since=7d`,
        feedBranch: 'Web Crawl Updates',
        feedTopic: 'N/A',
        buttonName: 'Page'
      }
    ]
  };
};

// Helper function to get state info
export const getStateInfo = (stateKey) => stateInfo[stateKey];

// Helper function to get state feeds by branch
export const getStateFeedsByBranch = (stateKey, branch) => {
  const stateFeeds = createStateFeeds(stateKey);
  if (!stateFeeds) return [];
  return stateFeeds[branch.toLowerCase()] || [];
};

// Helper function to get feeds by type
export const getFeedsByType = (sectionKey, type = 'normal') => {
  const sectionFeeds = feedsConfig[sectionKey] || [];
  return sectionFeeds.filter(feed => feed.type === type);
};

// Helper function to get normal feeds (backward compatibility)
export const getNormalFeeds = (sectionKey) => {
  return getFeedsByType(sectionKey, 'normal');
};

// Helper function to get carousel feeds
export const getCarouselFeeds = (sectionKey) => {
  return getFeedsByType(sectionKey, 'carousel');
};
// Helper functions for House configuration
export const getHouseConfig = () => feedsConfig.house;

export const getHouseCommittee = (committeeId) => {
  return feedsConfig.house.committees.find(committee => committee.id === committeeId);
};

export const getHouseCommittees = () => feedsConfig.house.committees;

export const getSenateConfig = () => feedsConfig.senate;

export const getSenateCommittee = (committeeId) => {
  return feedsConfig.senate.committees.find(committee => committee.id === committeeId);
};

export const getSenateCommittees = () => feedsConfig.senate.committees;